// eslint-disable-next-line no-useless-concat
/* eslint-disable no-loop-func */

import React, { useRef, useEffect ,useState } from "react";
import { Checkbox, Input, NumericTextBox, Switch } from "@progress/kendo-react-inputs";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { getter } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { GridColumn as Column, getSelectedState } from "@progress/kendo-react-grid";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { columnMenuProps } from "../../components/customColumnMenu";
import { DialogComponent } from "../../components/dialog";
import DataTable from "../../components/dataTable";
import { CellRender, RowRender } from "../../components/renderers";
import { DELETE_BTN_ACTIONS, NODE_NAME_LIST_FILTER } from "../../constants/constants";
import { DEFAULT_SORT, VIRTUAL_PAGE_SIZE } from "../../constants/grid";
import { getUserCredential, getTenantCookieData } from "../../lib/cookies";
import { removeMessage, setUnSavedChangesPopup } from "../../redux/actions/setting-actions";
import { GET_CUSTOM_TABLE_EFF_DATES, DELETE_CUSTOM_DATA, INSERT_CUSTOM_TABLE } from "../../api-setup/api-endpoints";
import {
  getfilterDataString,
  changeCancelBtnState,
  changeUpdateBtnState,
  microTime,
  applyFormat,
  formatDateOnlyMoment,
  applyDateFormat,
  escapeColumnName,
} from "../../utils/utils";
import useApi from "./dataRows/service";
import useCustomTableApi from "./service";
import {
  GetCompPlanDataApi,
  GetGroupNameAPI,
  GetPeriodsDataList,
  GetPositionDataAPI,
  GetSPECIALTYAPI,
  GetTeamNameApi,
} from "../../lib/common-service";
import { useHistory } from "react-router-dom";
import { DropDownCell, NodeNameDropdownCell, PeriodNameDropDownCell } from "./dataRows/dropdownCell";
import { unSaveChangesPopupSelector } from "src/redux/selectors/custom-selector";
import { ToggleButton } from "@progress/kendo-react-dateinputs";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { transformDateTime } from "src/lib/date-time.util";
import { Label } from "@progress/kendo-react-labels";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { LoadingPanel } from "src/components/loadingPanel";
import CustomDropdown from "src/components/customDropdown";
import moment from "moment";
import { Skeleton } from "@progress/kendo-react-indicators";
import MultiSelectDropdown from "../../components/multiSelect";
import { Dialog, DialogActionsBar, Window } from "@progress/kendo-react-dialogs";
import { EffectiveVersions } from "src/components/effectiveVersions";
import EffDataRowsApi from "../../components/effectiveVesionService";
import DtuBatchLogs from "../common/dtuBatchLogs";
import UploadDtu from "../user/uploadDtu";
import { HeaderPage } from "../base/headerPage";
import { IntlService } from "@progress/kendo-react-intl";

const intl = new IntlService("en");

const UNIT_FORMAT_TENANTS = ["innovetive01"];

const formatUnitValue = (value, format) => {
  if (
    !UNIT_FORMAT_TENANTS.includes(getUserCredential()?.out_tenant_id) ||
    !format ||
    format.startsWith("{") ||
    value === "" ||
    value === null ||
    value === undefined ||
    isNaN(value)
  ) {
    return value;
  }
  return intl.formatNumber(intl.parseNumber(value), format);
};

const editFieldTier = "inEdit";
const SELECTED_FIELD = "selected";
const DATA_ITEM_KEY = "custom_data_order";
const idGetter = getter(DATA_ITEM_KEY);

const NameCell = (props) => {
  const { ariaColumnIndex, columnIndex, dataItem, field, render } = props;
  const isInEdit = field === dataItem.inEdit;
  const inputRef = useRef(null);
  const caretPosition = useRef(null);
  let custom_table_mstr_key = dataItem?.custom_table_mstr_key;
  const requiredMsgVal = `${field}_msg`;

  const handleChange = (e) => {
    caretPosition.current = e.target.selectionStart;

    changeCancelBtnState("enable", "grid-incell-cancel-" + custom_table_mstr_key);
    changeUpdateBtnState("enable", "grid-incell-update-" + custom_table_mstr_key);

    if (props.onChange) {
      props.onChange({
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value,
      });
    }
  };

  useEffect(() => {
    if (isInEdit && inputRef.current && caretPosition.current !== null) {
      requestAnimationFrame(() => {
        inputRef.current.setSelectionRange(caretPosition.current, caretPosition.current);
      });
    }
  }, [dataItem[field]]);

  const defaultRendering = (
    <td aria-colindex={ariaColumnIndex} data-grid-col-index={columnIndex}>
      {isInEdit ? (
        <input
          ref={inputRef}
          value={dataItem[field]}
          onChange={handleChange}
          className="table-input k-textbox"
          name={field}
          autoFocus
        />
      ) : (
        <LoadingCell props={props} val={dataItem[field] || ""} />
      )}
      <div role="alert" className="k-form-error k-text-start text-wrap custom-table-data-err-msg">
        {dataItem[requiredMsgVal]}
      </div>
    </td>
  );

  return render?.call(undefined, defaultRendering, props);
};

const LoadingCell = (restProps) => {
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setIsLoading(false); // Stop showing skeleton after delay
    }, 10);
    return () => clearTimeout(timeout); // Clean up timeout
  }, []);

  // Show skeleton loader while loading
  if (isLoading) {
    return (
      <Skeleton
        shape="text"
        style={{
          width: "100%",
        }}
      />
    );
  }
  return <span title={restProps.val}>{restProps.val}</span>;
};

const loadingPanel = (
  <div className="k-loading-mask">
    <span className="k-loading-text">Loading</span>
    <div className="k-loading-image"></div>
    <div className="k-loading-color"></div>
  </div>
);

const BOOLEAN_DRP_DATA = [
  {
    text: "Select All",
    value: "0",
  },
  {
    text: "True",
    value: 1,
  },
  {
    text: "False",
    value: 0,
  },
];
const CustomTablesdataPopup = (restProps) => {
  const { versionData, pageProps, masterTableData } = restProps;
  const history = useHistory();
  const _ref = React.useRef(null);
  const containerRef = React.useRef(null);
  const [effVersionLoadingState, setEffVersionLoadingState] = React.useState(false);
  const [isShow, setShow] = React.useState({
    export: false,
    deleteRows: false,
    deleteAllRows: false
  });
  const [effVersionState, setEffVersionState] = React.useState({
    changeVersion: { rowId: -1, versionIdx: -1 },
    insertVersion: { rowId: -1, periodKey: 0 },
    deleteVersion: { rowId: -1 },
  });
  const [changeVersion, setChangeVersion] = React.useState(false);
  const [listVersion, ActionVersion] = EffDataRowsApi();
  const defaultPageSizevs = getTenantCookieData("record_per_page");
  const effVersionDetails = versionData.effVersionDetails;
  const { unsavedPopup } = useSelector(unSaveChangesPopupSelector, shallowEqual);
  const [gridKey, setGridKey] = React.useState(0);
  const selectedVersion = effVersionDetails.data.filter((x) => x.isSelected === 1)[0];

  const dispatch = useDispatch();
  const cookiesData = getUserCredential();
  const defaultPageSize = {
    skip: 0,
    recordTake: VIRTUAL_PAGE_SIZE,
  };
  const [modal, setModal] = React.useState(true);
  const [stageChange, setStateChange] = React.useState("DEFAULT");
  const [list, Action] = useApi();
  const [deleteSelectedIds, setDeleteSelectedIds] = React.useState([]);
  const [pageDatavs, setPagevs] = React.useState({
    skip: 0,
    take: defaultPageSizevs.recordTake,
  });
  const [, CustomTableAction] = useCustomTableApi();
  const {
    data,
    columns,
    setData,
    originalData,
    isAPICalling,
    setConfirmationPopup,
    confirmationPopup,
    setAPICallingState,
    initialLoading,
    setRefreshLoading,
    isRefreshLoading,
    setOriginalData,
    setDataRowsCount,
    setColumns,
    dataRowsCount,
    setLoadingState,
  } = list;
  // const [duplicateRecord ,setDuplicateRecordFound] = React.useState(false)
  //state to set and get limit, offset
  const [pageData, setPage] = React.useState({
    skip: 0,
    take: defaultPageSize.recordTake,
  });

  const [gridData, setGridData] = React.useState([]);
  const [filterField, setFilterField] = React.useState({ logic: "and", filters: [] });
  const [sortField, setSortField] = React.useState([]);
  const [pageSize, setPageSize] = React.useState(defaultPageSizevs);
  const [isPageApplied, setisPageApplied] = React.useState(false);
  //state to set and get filter, sort number, sort order
  const [filterData, setFilterData] = React.useState({
    isSort: false,
    isFilter: false,
    data: "",
    in_sort_number: DEFAULT_SORT.number,
    sort_order: DEFAULT_SORT.order,
  });

  const [exportData, setExportData] = React.useState([]);
  const [selectedState, setSelectedState] = React.useState({});
  const [errorObj, setErrorObj] = React.useState({});
  const [gridColumns, setGridColumns] = React.useState([]);
  // const [nodeNameList, setNodeNameList] = React.useState([]);
  const [customTableColumns, setCustomTableColumns] = React.useState([]);
  const [customTableColumnsDropDown, setCustomTableColumnsDropDown] = React.useState([]);
  const [isSearchBtnClick, setIsSearchBtnClick] = React.useState(false);
  const [searchData, setSearchData] = React.useState({
    in_data_filter: "",
    in_data_filter_count: "",
  });
  const [resetSort, setResetSort] = React.useState(false);
  const [nodeFields, setNodeFields] = React.useState({
    nodeList: [],
    nodeValue: NODE_NAME_LIST_FILTER[0],
  });
  const [periodFields, setPeriodFields] = React.useState({
    periodList: [],
    periodValue: NODE_NAME_LIST_FILTER[0],
  });
  const [nodeNameFields, setNodeNameFields] = React.useState({
    nodeNameList: [],
    nodeNameValue: "",
    isNodeNameLoading: false,
  });
  const [periodNameFields, setPeriodNameFields] = React.useState({
    periodNameList: [],
    periodNameValue: "",
    isPeriodNameLoading: false,
  });
  const [isSelectedField, setSelectedField] = React.useState(false);

  const [selectedRowId, setSelectedRowId] = React.useState("");
  const [columnsData, setColumnsData] = React.useState([]);
  const [isCheckColumn, setColumnCheck] = React.useState(false);
  const [isAddNewConfig, setNewConfig] = React.useState(false);
  const [exportDataClick, setExportDataClick] = React.useState(false);
  const [customTableDataAddUpdate, setCustomTableDataAddUpdate] = React.useState(false);
  const [scrollTop, setScrollTop] = React.useState(0);
  const [tierData, setTierData] = React.useState(effVersionDetails?.tierData || {});
  const addRef = React.useRef(null);

  const [periodNameListData, setPeriodNameListData] = React.useState([]);
  const [periodNameList, setPeriodNameList] = React.useState([]);
  const [PERIOD_NAME_LIST_FILTER, setPERIOD_NAME_LIST_FILTER] = React.useState([]);
  const [periodNameListGrid, setPeriodNameListGrid] = React.useState([]);

  useEffect(() => {
    getPeriodsDataList();
  }, []);

  const addNewConfig = (e) => {
    setNewConfig(!isAddNewConfig);
    e.preventDefault();
  };

  const AddNewLink = () => {
    return (
      <>
        <a
          href="/#"
          className="cta-small"
          ref={addRef}
          onClick={(e) => {
            addNewConfig(e);
          }}
        >
          <i className="fas fa-plus"></i> Add New Row
        </a>
      </>
    );
  };

  const handleMenuItemClick = (action) => {
    switch (action) {
      case "export":
        setExportDataClick(true);
        break;
      case "delete":
        setShow({
          ...isShow,
          deleteRows: !isShow.deleteRows,
        });
        break;
      case "dtuLogs":
        setShow({
          ...isShow,
          dtuLogs: !isShow.dtuLogs,
        });
        break;
      case "Delete All inPeriod":
        setShow({
          ...isShow,
          deleteAllRows: !isShow.deleteAllRows,
        });
        break;
      default:
        break;
    }
  };

  const handleUpload = (e) => {
    setShow({
      ...isShow,
      dtuUpload: !isShow.dtuUpload,
    });
    e.preventDefault();
  };

  const headerConfig = {
    // title: versionData.custom_table_name
    //     ? "Custom Table Data | " + versionData.custom_table_name
    //     : "Custom Table Data",
    id: "rate-tier-tables-" + versionData.custom_table_mstr_key,
    add_new_fx: AddNewLink,
    upload_fx: handleUpload,
    upload_title: "Custom Table Data",
    buttons: {
      template_fx: GridButton,
      args: {
        custom_table_mstr_key: versionData.custom_table_mstr_key,
      },
    },
    action_menu: {
      dtuLog: { fx: handleMenuItemClick },
      export: { fx: handleMenuItemClick },
      deleteAll: { fx: handleMenuItemClick, caption: 'Delete All Rows' },
      delete: { fx: handleMenuItemClick },
    },
    manage_col: {
      columnsData: columnsData,
      setColumnsData: setColumnsData,
      setColumnCheck: setColumnCheck,
    },
  };

  const parent = document.querySelector("#content-" + headerConfig.id);

  if (parent) {
    const exportToExcel = parent.querySelector(".export-to-excel");
    const auditLog = parent.querySelector(".audit-log");
    const deleteRows = parent.querySelector(".delete-rows");
    const deleteAllRows = parent.querySelector(".delete-allrows-batch")

    exportToExcel && exportToExcel.disableKendoMenu();
    auditLog && auditLog.disableKendoMenu();
    deleteRows && deleteRows.disableKendoMenu();
    deleteAllRows && deleteAllRows.disableKendoMenu();

    if (dataRowsCount > 0) {
      exportToExcel && exportToExcel.enableKendoMenu();

    }

    if (data.length > 0) {
      deleteAllRows && deleteAllRows.enableKendoMenu()

    }

    if (data.length > 0) {
      const isAnyRowSelected = data.some((row) =>
        deleteSelectedIds.some(
          (item) => Number(item.id) === Number(row.custom_data_order)
        )
      );

      if (isAnyRowSelected) {
        deleteRows && deleteRows.enableKendoMenu();
      }
    }

    // if (selectedRowId !== "") {
    //   auditLog && auditLog.enableKendoMenu();
    //   deleteRows && deleteRows.enableKendoMenu();
    // }
  }
  useEffect(() => {
    if (data.length == 0) {
      setSelectedRowId("");
    }
  }, [data]);

  const tierApiCallData = {
    in_tenant_id: cookiesData.out_tenant_id,
    in_custom_table_mstr_key: 0,
    in_date_version: 0,
    in_filter: null,
    in_sort_number: DEFAULT_SORT.number,
    in_sort_order: DEFAULT_SORT.order,
    in_page_row_offset: 0,
    in_page_rows: defaultPageSize.recordTake,
    in_user_role_filter: "> 0",
    in_load_type: "grid-reload",
    in_init: 1,
  };

  const apiCallData = {
    ...tierApiCallData,
    in_custom_table_mstr_key: versionData.custom_table_mstr_key,
    in_date_version: selectedVersion.dateVersion,
    in_load_type: "data-reload",
    in_init: 1,
    selectedVersion: selectedVersion,
    in_is_audit_log: 0,
  };

  React.useEffect(() => {
    if (versionData.data_filter_access === 0 && data.length === 0) {
      const initialTierData = versionData.effVersionDetails?.tierData;
      if (initialTierData) {
        const initialRows = initialTierData.rateTierData || [];
        const initialColumns = initialTierData.rateTierColumn || [];

        setData(initialRows);
        setOriginalData(initialRows);
        setColumns(initialColumns);
        setDataRowsCount(initialTierData.dataCount || 0);
        setTierData(initialTierData);
        setLoadingState(true);
        setAPICallingState(false);
      } else {
        const dataVal = {
          ...apiCallData,
          in_filter: getInFilter(),
          in_sort_number: getInSortNumber(),
          in_sort_order: getInSortOrder(),
          in_page_row_offset: 0,
          in_page_rows: defaultPageSizevs.recordTake,
          in_is_audit_log: 0,
        };
        getGridData(dataVal);
      }
    }

    // Scroll to the selected version tab after initial data is loaded
    const el = containerRef.current;
    if (el && versionData.effVersionDetails && versionData.effVersionDetails.data) {
      // Find the TabStrip items container
      const tabStripItems = el.querySelector(".k-tabstrip-items");
      if (tabStripItems) {
        const tabItems = tabStripItems.querySelectorAll(".k-item");
        const selectedIndex = versionData.effVersionDetails.data.findIndex((x) => x.isSelected === 1);
        if (selectedIndex >= 0 && tabItems[selectedIndex]) {
          tabItems[selectedIndex].scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest",
          });
        }
      }
    }
  }, [versionData]);

  React.useEffect(() => {
    if (modal === true) {
      if (customTableDataAddUpdate === false) {
        changeCancelBtnState("disable", "grid-incell-cancel-" + versionData.custom_table_mstr_key);
        changeUpdateBtnState("disable", "grid-incell-update-" + versionData.custom_table_mstr_key);
      }
    }
  }, [modal]);

  if (document.getElementById("grid-incell-cancel-" + versionData.custom_table_mstr_key)) {
    document.getElementById("grid-incell-cancel-" + versionData.custom_table_mstr_key).onclick = function (e) {
      changeCancelBtnState("disable", "grid-incell-cancel-" + versionData.custom_table_mstr_key);
      changeUpdateBtnState("disable", "grid-incell-update-" + versionData.custom_table_mstr_key);
      let tempData = [...originalData];
      tempData.map((item) => {
        item.inEdit = false;
        item.selected = false;
        return 0;
      });
      const freshData = tempData.filter((x) => x.isAdd === true);
      if (freshData.length > 0) {
        tempData.shift();
      }
      setData(tempData);
      setErrorObj({});
      dispatch(
        removeMessage({
          message: "",
          type: "Error",
          show: false,
        })
      );
      setDeleteSelectedIds([])
      setSelectedRowId("");
      setSelectedState({});
      setCustomTableDataAddUpdate(false);
      //disable in-cell update and cancel button
      e.target.disableKendoBtn();
      if (_ref.current) {
        const scrollableElement = _ref.current.querySelector(".k-grid-content");
        if (scrollableElement) {
          scrollableElement.scrollTop = 0;
        }
      }
      // TODO : UNSAVED CHANGES
      // dispatch(setUnSavedChangesPopup({ ...unsavedPopup, isUnSavedChange: false }));
    };
  }

  if (document.getElementById("grid-incell-update-" + versionData.custom_table_mstr_key)) {
    document.getElementById("grid-incell-update-" + versionData.custom_table_mstr_key).onclick = function (e) {
      handleUpdate();
    };
  }

  /**
   * call list eff version API
   */
  const getEffVersionsApi = async (mstrKey) => {
    setRefreshLoading(true);
    const versionProps = {
      apiEndPoints: { listApi: GET_CUSTOM_TABLE_EFF_DATES },
      dataItem: { mstr_key: mstrKey },
      pageProps: { writeAccess: pageProps.writeAccess },
    };

    const versionApiCallData = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_mstr_key: mstrKey,
      in_sort_number: 1,
      in_sort_order: "ASC",
    };
    //get response for eff version tab
    let effVersionResponse = await ActionVersion.getListDataAsync(versionApiCallData, versionProps);
    const currentEndDate = effVersionResponse.currentVersionEndDate;
    //get response for eff version period menu
    const periodDataResponse = await ActionVersion.getPeriodsDataTypeAsync(currentEndDate);
    if (effVersionResponse.data.length > 0) {
      effVersionResponse["periodsData"] = periodDataResponse;
      const selectedVersion = effVersionResponse.data.filter((x) => x.isSelected === 1)[0];

      const tierDataVal = {
        ...tierApiCallData,
        in_custom_table_mstr_key: mstrKey,
        in_date_version: selectedVersion?.dateVersion,
        selectedVersion: selectedVersion,
        in_page_row_offset: 0,
        in_page_rows: defaultPageSizevs.recordTake,
        in_is_audit_log: 0,
      };
      let masterTableDataList = masterTableData.slice();
      let parentIndex = masterTableDataList.findIndex(
        (x) => x.custom_table_mstr_key === tierDataVal.in_custom_table_mstr_key
      );
      if (parentIndex > -1) {
        if (masterTableDataList[parentIndex].data_filter_access === 0) {
          const tierData = await Action.getListDataAsync(tierDataVal);
          effVersionResponse["tierData"] = tierData;
          setRefreshLoading(false);
        } else {
          const tierData = await Action.getCustomTableListDataAsync(tierDataVal);
          effVersionResponse["tierData"] = tierData;
          setRefreshLoading(false);
        }
      }
    } else {
      onClosePopup();
    }

    return effVersionResponse;
  };

  /**
   * call delete eff version API
   */
  React.useEffect(() => {
    let masterTableDataList = masterTableData.slice();
    const deleteVersion = effVersionState.deleteVersion;
    if (masterTableDataList.length > 0 && deleteVersion.rowId !== -1) {
      const mstrDeta = masterTableDataList[deleteVersion.rowId];
      const thisEffVersionDeta = mstrDeta.effVersionDetails.data;

      const selectedVersion = thisEffVersionDeta.filter((x) => x.isSelected === 1)[0];
      const bodyData = {
        in_user_id: cookiesData.out_user_id,
        in_custom_table_mstr_key: [
          {
            id: mstrDeta.custom_table_mstr_key,
            in_date_version: selectedVersion.dateVersion,
          },
        ],
        in_tenant_id: cookiesData.out_tenant_id,
      };
      setChangeVersion(true);
      setEffVersionLoadingState(true);
      ActionVersion.deleteDataAsync({
        api: DELETE_CUSTOM_DATA,
        bodyData: bodyData,
      });
    }
  }, [effVersionState.deleteVersion]);

  //change eff version
  React.useEffect(async () => {
    setPeriodFields({
      ...periodFields,
      periodValue: { text: "Select All", value: "" },
    });
    let masterTableDataList = masterTableData.slice();
    if (masterTableDataList.length > 0 && effVersionState.changeVersion.rowId > -1) {
      setEffVersionLoadingState(true);
      const versionState = effVersionState.changeVersion;
      const mstrRow = masterTableDataList[versionState.rowId];
      let thisEffVersionDeta = mstrRow.effVersionDetails.data;

      thisEffVersionDeta
        .filter((x) => x.isSelected === 1)
        .map((item) => {
          item.isSelected = 0;
          return 0;
        });

      const newSelectedVersion = thisEffVersionDeta[versionState.versionIdx];
      setFilterField({ logic: "and", filters: [] });
      setSortField([]);
      setData([])
      setGridData([])
      setDeleteSelectedIds([])
      setSelectedRowId("")
      setSelectedState({})
      newSelectedVersion.isSelected = 1;
      newSelectedVersion.endDate = mstrRow.effVersionDetails.currentVersionEndDate;
      const tierDataVal = {
        ...tierApiCallData,
        in_custom_table_mstr_key: mstrRow.custom_table_mstr_key,
        in_date_version: newSelectedVersion.dateVersion,
        in_filter: null,
        in_sort_number: DEFAULT_SORT.number,
        selectedVersion: newSelectedVersion,
        in_page_rows: defaultPageSizevs.recordTake,
        in_page_row_offset: 0,
        in_is_audit_log: 0,
      };
      setChangeVersion(true);
      changeCancelBtnState("disable", "grid-incell-cancel-" + mstrRow.custom_table_mstr_key);
      changeUpdateBtnState("disable", "grid-incell-update-" + mstrRow.custom_table_mstr_key);
      if (versionData.data_filter_access === 0) {
        const tierData = await Action.getListDataAsync(tierDataVal);
        mstrRow.effVersionDetails.tierData = tierData;
        restProps.setMasterTableData([...masterTableData]);
      }
      setEffVersionLoadingState(false);


      // Scroll to the selected version tab after version change
      const el = containerRef.current;
      if (el) {
        // Find the TabStrip items container
        const tabStripItems = el.querySelector(".k-tabstrip-items");
        if (tabStripItems) {
          const tabItems = tabStripItems.querySelectorAll(".k-item");
          const selectedIndex = thisEffVersionDeta.findIndex((x) => x.isSelected === 1);
          if (selectedIndex >= 0 && tabItems[selectedIndex]) {
            tabItems[selectedIndex].scrollIntoView({
              behavior: "smooth",
              inline: "center",
              block: "nearest",
            });
          }
        }
      }
    }
  }, [effVersionState.changeVersion]);

  /**
   * update dataset after insert a new version
   */
  React.useEffect(async () => {
    if (listVersion.loadingState.isSaveData === true) {
      let masterTableDataList = masterTableData.slice();

      const mstrIdx = effVersionState.insertVersion.rowId;
      const mstrDeta = masterTableDataList[mstrIdx];

      let effVersionResponse = await getEffVersionsApi(mstrDeta.custom_table_mstr_key);

      masterTableDataList[mstrIdx].effVersionDetails = effVersionResponse;
      setChangeVersion(true);
      setEffVersionState({
        ...effVersionState,
        insertVersion: { rowId: -1, periodKey: 0 },
      });
      restProps.setMasterTableData(masterTableData);
      setEffVersionLoadingState(false);
      changeCancelBtnState("disable", "grid-incell-cancel-" + mstrDeta.custom_table_mstr_key);
      changeUpdateBtnState("disable", "grid-incell-update-" + mstrDeta.custom_table_mstr_key);

      // Scroll to the newly added version tab (last element)
      const el = containerRef.current;
      if (el && el.lastElementChild) {
        el.lastElementChild.scrollIntoView({
          behavior: "smooth",
          inline: "end", // align last child to the right edge
          block: "nearest",
        });
      }
    }
  }, [listVersion.loadingState.isSaveData]);

  /**
   * call add eff version API
   */
  React.useEffect(() => {
    let masterTableDataList = masterTableData.slice();
    const insertVersion = effVersionState.insertVersion;

    if (masterTableDataList.length > 0 && insertVersion.periodKey) {
      setEffVersionLoadingState(true);
      const mstrDeta = masterTableDataList[insertVersion.rowId];

      const bodyData = {
        in_user_id: cookiesData.out_user_id,
        in_tenant_id: cookiesData.out_tenant_id,
        in_custom_table_mstr_key: mstrDeta.custom_table_mstr_key,
        in_custom_table_name: mstrDeta.custom_table_name,
        in_custom_table_desc: mstrDeta.custom_table_desc,
        in_custom_table_type: mstrDeta.custom_table_type,
        in_period_mstr_key: insertVersion.periodKey,
      };

      ActionVersion.addDataAsync({
        api: INSERT_CUSTOM_TABLE,
        bodyData: bodyData,
      });
    }
  }, [effVersionState.insertVersion]);

  /**
   * update dataseta fter delete an existing version
   */
  React.useEffect(async () => {
    if (listVersion.loadingState.isDeleteData === true) {
      let masterTableDataList = masterTableData.slice();
      const mstrIdx = effVersionState.deleteVersion.rowId;
      const mstrDeta = masterTableDataList[mstrIdx];

      let effVersionResponse = await getEffVersionsApi(mstrDeta.custom_table_mstr_key);
      if (!effVersionResponse.data.length) {
        setSelectedRowId("");
        setDeleteSelectedIds([]);
        setAPICallingState(true);
        const dataVal = {
          ...apiCallData,
          in_filter: getInFilter(),
          in_sort_number: getInSortNumber(),
          in_sort_order: getInSortOrder(),
          in_page_row_offset: 0,
          in_page_rows: defaultPageSizevs.recordTake,
          in_is_audit_log: 0,
        };
        getGridData(dataVal, "delete");
        restProps.onRefreshClick();
      } else {
        masterTableData[mstrIdx].effVersionDetails = effVersionResponse;
      }
      setEffVersionState({
        ...effVersionState,
        deleteVersion: { rowId: -1 },
      });
      restProps.setMasterTableData(masterTableData);
      setEffVersionLoadingState(false);
      changeCancelBtnState("disable", "grid-incell-cancel-" + mstrDeta.custom_table_mstr_key);
      changeUpdateBtnState("disable", "grid-incell-update-" + mstrDeta.custom_table_mstr_key);

      // Scroll to the newly selected version tab after deletion
      const el = containerRef.current;
      if (el && el.children.length > 0 && effVersionResponse.data.length > 0) {
        const selectedIndex = effVersionResponse.data.findIndex((x) => x.isSelected === 1);
        if (selectedIndex >= 0 && el.children[selectedIndex]) {
          el.children[selectedIndex].scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest",
          });
        }
      }
    }
  }, [listVersion.loadingState.isDeleteData]);

  React.useEffect(() => {
    if (changeVersion) {
      setDataRowsCount(0);
      setFilterData({
        ...filterData,
        isSort: false,
        isFilter: false,
        data: "",
      });
      setPageSize(defaultPageSizevs);
      setPage({
        skip: 0,
        take: defaultPageSize.recordTake,
      });
      setPagevs({
        skip: 0,
        take: defaultPageSizevs.recordTake,
      });
      setCustomTableColumns([]);
      setCustomTableColumnsDropDown([]);
      setSelectedRowId("");
      setSelectedState({});
      setChangeVersion(false);
      setSearchData({
        in_data_filter: "",
        in_data_filter_count: "",
      });
      setIsSearchBtnClick(false);
      setNodeFields({
        nodeList: [],
        nodeValue: NODE_NAME_LIST_FILTER[0],
      });
      setNodeNameFields({
        nodeNameList: [],
        nodeNameValue: "",
        isNodeNameLoading: false,
      });
      changeCancelBtnState("disable", "grid-incell-cancel-" + versionData.custom_table_mstr_key);
      changeUpdateBtnState("disable", "grid-incell-update-" + versionData.custom_table_mstr_key);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeVersion]);

  const getNodeNames = async (nodeName, index, dataItem, field) => {
    if (index > -1) {
      let editIndex = index;
      let newData = data.map((item) => ({
        ...item,
        inEdit: item.custom_data_order === dataItem.custom_data_order ? field : undefined,
      }));
      let dataList = newData.slice();
      switch (nodeName) {
        case "position":
          let dataObject = {
            in_tenant_id: cookiesData.out_tenant_id,
            in_filter: null,
            in_user_key: cookiesData.out_user_id,
            in_sort_number: 2,
            in_sort_order: "ASC",
            in_page_row_offset: 0,
            in_page_rows: 9999,
            in_acct_encrypt_key: cookiesData.out_acct_encrypt_key,
            in_user_role_filter: null,
            in_export_flag: 0,
            in_is_current_flag: 1,
          };
          let resDataObject = await GetPositionDataAPI(dataObject, history, dispatch);
          if (resDataObject && resDataObject.length) {
            const tempData = resDataObject
              .filter((x) => x.position_name !== "")
              .map((item) => ({
                text: item.position_name,
                value: item.org_position_key,
              }));
            // setNodeNameList([...tempData]);
            dataList[editIndex].nodeNameList.data = tempData;
            dataList[editIndex].nodeNameList.loadingState = true;
            setData([...dataList]);
          } else {
            dataList[editIndex].nodeNameList.data = [];
            dataList[editIndex].nodeNameList.loadingState = true;
            setData([...dataList]);
          }
          break;
        case "team":
          let reqData = {
            in_tenant_id: cookiesData.out_tenant_id,
            in_eff_end_date: selectedVersion.endDate,
          };
          let res = await GetTeamNameApi(reqData, history, dispatch);
          if (res && res.length) {
            const tempData = res.map((item) => ({
              text: item.team_name,
              value: item.team_name,
            }));
            // setNodeNameList([...tempData]);
            dataList[editIndex].nodeNameList.data = tempData;
            dataList[editIndex].nodeNameList.loadingState = true;
            setData([...dataList]);
          } else {
            dataList[editIndex].nodeNameList.data = [];
            dataList[editIndex].nodeNameList.loadingState = true;
            setData([...dataList]);
          }
          break;
        case "group":
          let dataValue = {
            in_tenant_id: cookiesData.out_tenant_id,
            in_filter: null,
            in_user_role_filter: null,
            in_sort_number: 3,
            in_sort_order: null,
            in_page_row_offset: 0,
            in_page_rows: 9999,
          };
          let resData = await GetGroupNameAPI(dataValue, history, dispatch);
          if (resData && resData.length) {
            const tempData = resData.map((item) => ({
              text: item.title_name,
              value: item.org_title_key,
            }));
            // setNodeNameList([...tempData]);
            dataList[editIndex].nodeNameList.data = tempData;
            dataList[editIndex].nodeNameList.loadingState = true;
            setData([...dataList]);
          } else {
            dataList[editIndex].nodeNameList.data = [];
            dataList[editIndex].nodeNameList.loadingState = true;
            setData([...dataList]);
          }
          break;
        case "specialty":
          let dataObjValue = {
            in_user_key: cookiesData.out_user_id,
            in_tenant_id: cookiesData.out_tenant_id,
            in_filter: null,
            in_sort_number: 3,
            in_sort_order: "DESC",
            in_page_row_offset: 0,
            in_page_rows: 9999,
          };
          let resDataObjValue = await GetSPECIALTYAPI(dataObjValue, history, dispatch);
          if (resDataObjValue && resDataObjValue.length) {
            const tempData = resDataObjValue.map((item) => ({
              text: item.specialty_name,
              value: item.specialty_mstr_key,
            }));
            // setNodeNameList([...tempData]);
            dataList[editIndex].nodeNameList.data = tempData;
            dataList[editIndex].nodeNameList.loadingState = true;
            setData([...dataList]);
          } else {
            dataList[editIndex].nodeNameList.data = [];
            dataList[editIndex].nodeNameList.loadingState = true;
            setData([...dataList]);
          }
          break;
        case "plan":
          let dataObj = {
            in_tenant_id: cookiesData.out_tenant_id,
            in_filter: null,
            in_sort_number: null,
            in_sort_order: null,
            in_user_key: cookiesData.out_user_id,
            in_multi_sort_order: null,
          };
          let resDataObj = await GetCompPlanDataApi(dataObj, history, dispatch);
          if (resDataObj && resDataObj.length) {
            const tempData = resDataObj.map((item) => ({
              text: item.comp_plan_name,
              value: item.comp_plan_mstr_key,
            }));
            // setNodeNameList([...tempData]);
            dataList[editIndex].nodeNameList.data = tempData;
            dataList[editIndex].nodeNameList.loadingState = true;
            setData([...dataList]);
          } else {
            dataList[editIndex].nodeNameList.data = [];
            dataList[editIndex].nodeNameList.loadingState = true;
            setData([...dataList]);
          }
          break;
        default:
          break;
      }
    }
  };

  React.useEffect(() => {
    if (customTableColumns.length === 0) {
      getCustomTableData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customTableColumns]);

  const getCustomTableData = async () => {
    let reData = {
      in_filter: null,
      in_custom_table_mstr_key: versionData.custom_table_mstr_key,
      in_sort_number: 1,
      in_sort_order: "DESC",
      in_multi_sort_order: null,
      in_page_row_offset: 0,
      in_page_rows: getPageTake(),
    };
    let res = await CustomTableAction.getCustomTableColumns(reData);
    let findIndex = res.findIndex((x) => x.custom_col_is_key === 1 && x.data_type_name.toLowerCase() === "boolean");
    let resData = [...res];
    // if (versionData.custom_table_type ===
    //     "H") {
    //     resData = resData.filter((x) => x.custom_col_name !== 'Node' && x.custom_col_name !== 'Node_Name')
    // }
    if (findIndex > -1) {
      resData[findIndex].valueData = BOOLEAN_DRP_DATA[0];
      setCustomTableColumns([...resData]);
      setCustomTableColumnsDropDown([...resData]);
    } else {
      let index = res.findIndex(
        (x) =>
          x.custom_col_is_key === 1 &&
          x.custom_col_name.toLowerCase() === "node" &&
          versionData.custom_table_type === "H"
      );
      if (index > -1) {
        resData[index].data = NODE_NAME_LIST_FILTER;
        setCustomTableColumns([...resData]);
        setCustomTableColumnsDropDown([...resData]);
      } else {
        setCustomTableColumns([...resData]);
        setCustomTableColumnsDropDown([...resData]);
      }
    }
    changeCancelBtnState("disable", "grid-incell-cancel-" + versionData.custom_table_mstr_key);
    changeUpdateBtnState("disable", "grid-incell-update-" + versionData.custom_table_mstr_key);
  };

  React.useEffect(() => {
    if (tierData?.rateTierColumn) {
      setColumns(tierData?.rateTierColumn);
      setColumnsData(tierData?.rateTierColumn);
      setGridColumns(tierData?.rateTierColumn || columns);
      setLoadingState(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tierData?.rateTierColumn]);

  React.useEffect(() => {
    if (isAddNewConfig) {
      let promise = new Promise(function (resolve, reject) {
        if (handleValidation()) {
          // if (handleUniqueValueValidation()) {
          addRow();
          // }
          setNewConfig(false);
          resolve("done");
        }
      });

      promise.then((result) => {
        const elements = document.getElementsByClassName("table-input");
        if (elements.length) {
          elements[0].focus();
        }
      }, null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAddNewConfig]);

  React.useEffect(() => {
    if (list?.loadingState?.isDeleteData) {
      list.setLoadState({ ...list.loadingState, isDeleteData: false });
      onRefreshClick();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list?.loadingState?.isDeleteData]);

  React.useEffect(() => {
    if (isShow?.deleteRows) {
      remove();
      setShow({ ...isShow, deleteRows: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShow?.deleteRows]);

  React.useEffect(() => {
    if (isCheckColumn) {
      setGridColumns(columnsData);
      setColumnCheck(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCheckColumn]);

  const getInFilter = () => {
    return filterData.isFilter ? filterData.data : null;
  };

  const getInSortNumber = () => {
    return filterData.isSort ? filterData.in_sort_number : DEFAULT_SORT.number;
  };

  const getInSortOrder = () => {
    return filterData.isSort ? filterData.sort_order : DEFAULT_SORT.order;
  };

  const getPageTake = () => {
    return pageDatavs.take;
  };

  const getPageSkip = () => {
    return pageDatavs.skip;
  };

  const addRow = () => {
    const freshKeyLen = data.filter((x) => x.custom_table_data_key === 0).length;

    let filterColumnsData = columns.filter((item) => item.filterable === "1");
    if (filterColumnsData.length > 0) {
      let initFields = {
        custom_table_mstr_key: versionData.custom_table_mstr_key,
        custom_data_order: microTime(),
        date_version: selectedVersion.dateVersion,
        inIteamEdit: true,
        in_filter: `AND a.period_start_date <= '${selectedVersion?.period_end_date}' AND a.period_end_date >= '${selectedVersion?.period_start_date}'`,
        isAdd: true,
        rowId: data.length + 1,
        nodeNameList: { data: [], loadingState: false },
      };
      filterColumnsData.map((item) => {
        initFields[item.field] = "";
        return 0;
      });
      if (freshKeyLen === 0) {
        let initialData = JSON.parse(JSON.stringify(initFields));
        // TODO : UNSAVED CHANGES
        // dispatch(
        //   setUnSavedChangesPopup({ ...unsavedPopup, isUnSavedChange: true })
        // );
        setSelectedState({ [initFields.custom_data_order]: true });
        data.unshift(initialData);
        setData([...data]);
        setDeleteSelectedIds([{ id: initFields.custom_data_order }]);
      }
      enterEdit(initFields, filterColumnsData[0].field);

      updateEnableButtonState();
      if (versionData.data_filter_access === 1) {
        setIsSearchBtnClick(true);
      }
      setCustomTableDataAddUpdate(true);
    }
  };

  const handleValidation = () => {
    let isValid = true;
    let dataList = data.slice();
    let errorObj = {};
    let obj = {};
    dataList
      .filter((x) => x.inIteamEdit === true)
      .map((cItem, i) => {
        customTableColumns
          .filter((x) => x.custom_col_is_key === 1 && x.data_type_name.toLowerCase() !== "boolean")
          .map((item) => {
            const { rowId } = cItem;
            if (item.data_type_name.toLowerCase() === "date" || item.data_type_name.toLowerCase() === "number") {
              if (cItem[item.custom_col_name] === "" || cItem[item.custom_col_name] === null) {
                let key = item.custom_col_name + "_msg";
                errorObj[item.custom_col_name] = `${[item.origin_custom_col_name]} is required`;
                cItem[key] = `${[item.origin_custom_col_name]} is required`;
                obj[`${item.custom_col_name + rowId}`] = `${[item.origin_custom_col_name]} is required`;
              }
            } else {
              if (
                cItem[item.custom_col_name] === undefined ||
                cItem[item.custom_col_name].trim() === "" ||
                cItem[item.custom_col_name].trim() === null
              ) {
                let key = item.custom_col_name + "_msg";
                if (
                  versionData.custom_table_type === "H" &&
                  (item.custom_col_name === "Node" || item.custom_col_name === "Node_Name")
                ) {
                  if (cItem.Node.toLowerCase() !== "plan") {
                    if (item.custom_col_name === "Node_Name") {
                      if (cItem["node_key"]?.value === undefined || cItem["node_key"]?.value === "") {
                        errorObj[item.custom_col_name] = `${[item.origin_custom_col_name]} is required`;
                        cItem[key] = `${[item.origin_custom_col_name]} is required`;
                        obj[`${item.custom_col_name + rowId}`] = `${[item.origin_custom_col_name]} is required`;
                      }
                    } else {
                      errorObj[item.custom_col_name] = `${[item.origin_custom_col_name]} is required`;
                      cItem[key] = `${[item.origin_custom_col_name]} is required`;
                      obj[`${item.custom_col_name + rowId}`] = `${[item.origin_custom_col_name]} is required`;
                    }
                  }
                } else {
                  errorObj[item.custom_col_name] = `${[item.origin_custom_col_name]} is required`;
                  cItem[key] = `${[item.origin_custom_col_name]} is required`;
                  obj[`${item.custom_col_name + rowId}`] = `${[item.origin_custom_col_name]} is required`;
                }
              }
            }
            setErrorObj(obj);
            for (const [, value] of Object.entries(obj)) {
              if (value.trim() !== "") {
                isValid = false;
              }
            }
            return 0;
          });
        return 0;
      });
    setData([...dataList]);
    return isValid;
  };

  const arraysAreEqual = (array1, array2) => {
    // Check if the lengths are the same
    if (array1.length !== array2.length) {
      return false;
    }

    // Function to compare two objects
    const areObjectsEqual = (obj1, obj2) => {
      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);

      // Check if the number of keys is the same
      if (keys1.length !== keys2.length) {
        return false;
      }

      // Check if all keys and values are the same
      for (let key of keys1) {
        if (obj1[key] !== obj2[key]) {
          return false;
        }
      }

      return true;
    };

    // Compare each object in the arrays
    for (let i = 0; i < array1.length; i++) {
      if (!areObjectsEqual(array1[i], array2[i])) {
        return false;
      }
    }

    return true;
  };

  const handleUniqueValueValidation = async () => {
    let isValid = true;
    let dataList = [...data];
    let errObj = {};
    let newData = dataList.map(({ Node_Name, custom_table_mstr_key, Node, ...rest }) => {
      return {
        Node_Name,
        custom_table_mstr_key,
        Node,
        ...rest,
      };
    });
    const resultArray = newData.map((dataItem) => {
      const tempNewArray = customTableColumns
        .filter((customCol) => customCol.custom_col_is_key === 1)
        .map((customCol, i) => {
          const colName = customCol.custom_col_name;
          const dataType = customCol.data_type_name.toLowerCase();
          const dataValue = dataItem[colName];
          const transformedValue =
            dataType === "date"
              ? transformDateTime({
                date: dataValue,
                format: "MM/DD/YYYY",
              })
              : dataType === "string"
                ? String(dataValue).toLowerCase().trim()
                : dataType === "boolean"
                  ? dataValue || false
                  : dataValue;
          return {
            in_custom_col_mstr_key: customCol.custom_col_mstr_key,
            in_data_value: transformedValue,
            in_custom_col_name: colName,
            in_origin_custom_col_name: customCol.origin_custom_col_name,
            index: i,
            dataType: customCol.data_type_name.toLowerCase(),
          };
        });

      return tempNewArray;
    });
    for (let i = 0; i < resultArray.length; i++) {
      for (let j = i + 1; j < resultArray.length; j++) {
        const array1 = resultArray[i];
        const array2 = resultArray[j];
        if (arraysAreEqual(array1, array2)) {
          let matchedArray = array1.filter((item1) =>
            array2.some(
              (item2) =>
                item1.in_custom_col_mstr_key === item2.in_custom_col_mstr_key &&
                item1.in_custom_col_name === item2.in_custom_col_name &&
                item1.in_data_value === item2.in_data_value
            )
          );
          let filterArray = [...matchedArray];
          if (versionData.custom_table_type === "H") {
            filterArray = matchedArray.filter((x) => x.in_origin_custom_col_name !== "Node");
          }

          if (filterArray.length > 0) {
            let keySet = filterArray
              .map((item) => {
                return item.in_origin_custom_col_name;
              })
              .toString();
            if (dataList.find((x) => x.inIteamEdit === true)) {
              let key = "";
              dataList
                .filter((x) => x.inIteamEdit === true)
                .map((dItem) => {
                  let findIndex = dataList.findIndex((x) => x.rowId === dItem.rowId);
                  filterArray.map((item, i) => {
                    let colName = item.in_custom_col_name;
                    let transformedValue =
                      item.dataType === "date"
                        ? transformDateTime({
                          date: dItem[colName],
                          format: "MM/DD/YYYY",
                        })
                        : item.dataType === "string"
                          ? String(dItem[colName]).toLowerCase().trim()
                          : item.dataType === "boolean"
                            ? dItem[colName] || false
                            : dItem[colName];
                    if (item.in_data_value === transformedValue) {
                      let keyColumns = customTableColumns
                        .filter((x) => x.custom_col_is_key === 1)
                        .map((c) => {
                          return c.custom_col_name;
                        });
                      if (keyColumns.includes(dItem.inEdit)) {
                        if (dItem.inEdit === item.in_custom_col_name) {
                          const tableInputs = document.getElementsByClassName("table-input");
                          let selectElement = null;
                          for (let i = 0; i < tableInputs.length; i++) {
                            selectElement = tableInputs[i].querySelector("select")?.name
                              ? tableInputs[i].querySelector("select")?.name
                              : tableInputs[i].querySelector("input")?.name;
                            if (selectElement) {
                              break;
                            } else {
                              selectElement = tableInputs[i].name;
                              break;
                            }
                          }
                          key = `${selectElement}${dItem.rowId}`;
                          if (key) {
                            isValid = false;
                            errObj[key] =
                              `All the current value of key field(s) ${keySet.toString()} matches the other row.`;
                            dataList[findIndex][key] =
                              `All the current value of key field(s) ${keySet.toString()} matches the other row.`;
                          }
                        }
                      } else {
                        key = `${item.in_custom_col_name}${dItem.rowId}`;
                        if (key) {
                          isValid = false;
                          errObj[key] =
                            `All the current value of key field(s) ${keySet.toString()} matches the other row.`;
                          dataList[findIndex][key] =
                            `All the current value of key field(s) ${keySet.toString()} matches the other row.`;
                        }
                      }
                    } else {
                      errObj[key] = "";
                      dataList[findIndex][key] = "";
                    }
                    return 0;
                  });
                  return 0;
                });
            }
          }
        }
      }
    }
    setData([...dataList]);
    setErrorObj({ ...errObj });
    return isValid;
  };

  // Helper function to handle empty strings and missing values
  function normalizeOrder(value) {
    return value === "" || value === undefined || value === null ? Infinity : Number(value);
  }

  const getGridData = async (dataVal, module) => {
    let response = await Action.getListDataAsync(dataVal);
    if (response.length) {
      switch (module) {
        case "update":
          setPageMenuState(response);
          setAPICallingState(false);
          break;
        case "delete":
          setPageMenuState(response);
          setAPICallingState(false);
          break;
        // case 'add':
        //   setDeleteSelectedIds([{'id' : response[0].custom_table_mstr_key }])
        //   setSelectedState({ [response[0].custom_table_mstr_key]: true });
        //   setPageMenuState(response);
        //   break;
        default:
          setPageMenuState(response);
          setAPICallingState(false);
          break;
      }
    } else {
      if (module === "filter") {
        setPageMenuState(response);
        setAPICallingState(false);
      }
      if (response.length === 0 && module === "update") {
        setPageMenuState(response);
        setAPICallingState(false);
      }
      if (!module) {
        setTierData(response);
      }
    }
  };

  const handleUpdate = async () => {
    let valid = await handleValidation();
    if (valid) {
      let dataList = data.filter((x) => x.inIteamEdit === true);

      let updatedDataList = [];
      let keyColumnList = [];
      dataList.map((xItem, i) => {
        let rowArray = []; // Store all custom column objects for a single record
        customTableColumns
          .filter((x) => x.custom_col_is_key === 1)
          .forEach((item) => {
            let obj = {
              in_user_id: cookiesData.out_user_id.toString(),
              in_tenant_id: cookiesData.out_tenant_id,
              in_date_version: selectedVersion.dateVersion,
              in_custom_data_order: xItem.custom_data_order,
              in_custom_table_mstr_key: versionData.custom_table_mstr_key,
              in_custom_col_mstr_key: item.custom_col_mstr_key,
              in_custom_col_name: escapeColumnName(item.custom_col_name),
              in_custom_col_is_key: item.custom_col_is_key,
              in_Node_Name: xItem["Node_Name"] || "",
              in_origin_custom_col_name: item.origin_custom_col_name,
              in_custom_table_type: versionData.custom_table_type,
            };

            let dataValue = "";

            if (item.data_type_name.toLowerCase() === "date") {
              dataValue =
                xItem[item.custom_col_name] !== "0000-00-00 00:00:00"
                  ? transformDateTime({
                    date: xItem[item.custom_col_name],
                    format: "YYYY-MM-DD",
                  })
                  : null;
            } else if (item.custom_col_name === "Node_Name") {
              if (xItem.Node === "Team" || xItem.Node === "Plan") {
                dataValue =
                  xItem.nodeNameList?.data.length > 0
                    ? xItem.nodeNameList.data.find((x) => x.value === xItem.node_key?.value)?.value
                    : xItem.Node_Name || "";
              } else {
                dataValue =
                  xItem.nodeNameList?.data.length > 0
                    ? xItem.nodeNameList.data.find((x) => x.value === xItem.node_key?.value)?.value
                    : xItem.node_key === 0
                      ? xItem.Node_Name || ""
                      : xItem.node_key;
              }
            } else if (item.data_type_name.toLowerCase() === "number") {
              dataValue = xItem[item.custom_col_name] ?? 0; // Default to 0 if null or empty
            } else {
              dataValue = xItem[item.custom_col_name];
            }

            // Ensure "0000-00-00 00:00:00" is treated as null
            if (dataValue === "0000-00-00 00:00:00") {
              dataValue = null;
            }

            obj.in_data_value = dataValue && typeof dataValue === "string" ? dataValue.trim() : dataValue;

            // Add object to row array
            rowArray.push(obj);
          });

        // Push the row's custom column data as an array inside updatedDataList
        keyColumnList.push(rowArray);
      });

      dataList.forEach((cItem, i) => {
        let rowArray = []; // Store all custom column objects for a single record
        let compareData = originalData.filter((x) => x.custom_data_order === cItem.custom_data_order);
        customTableColumns.forEach((item) => {
          let isUpdate = cItem.isAdd
            ? true
            : compareData[0][item.custom_col_name] === cItem[item.custom_col_name]
              ? false
              : true;
          //if (isUpdate) {
          let obj = {
            in_user_id: cookiesData.out_user_id.toString(),
            in_tenant_id: cookiesData.out_tenant_id,
            in_date_version: selectedVersion.dateVersion,
            in_custom_data_order: cItem.isAdd ? "" : cItem.custom_data_order,
            in_custom_table_mstr_key: versionData.custom_table_mstr_key,
            in_custom_col_mstr_key: item.custom_col_mstr_key,
            in_custom_col_name: escapeColumnName(item.custom_col_name),
            in_custom_col_is_key: item.custom_col_is_key,
            in_Node_Name: cItem["Node_Name"] || "",
            in_origin_custom_col_name: item.origin_custom_col_name,
            in_custom_table_type: versionData.custom_table_type,
            is_update: cItem.isAdd
              ? true
              : item.data_type_name.toLowerCase() === "string"
                ? compareData[0][item.custom_col_name]?.trim() === cItem[item.custom_col_name]?.trim()
                  ? false
                  : true
                : compareData[0][item.custom_col_name] === cItem[item.custom_col_name]
                  ? false
                  : true,
            customTableColumns: customTableColumns,
            keyColumnList:
              keyColumnList.length > 0
                ? keyColumnList.flat().filter((x) => x.in_custom_data_order === cItem.custom_data_order)
                : [],
          };

          let dataValue = "";

          if (item.data_type_name.toLowerCase() === "date") {
            dataValue =
              cItem[item.custom_col_name] !== "0000-00-00 00:00:00"
                ? transformDateTime({
                  date: cItem[item.custom_col_name],
                  format: "YYYY-MM-DD",
                })
                : null;
          } else if (item.custom_col_name === "Node_Name") {
            if (cItem.Node === "Team" || cItem.Node === "Plan") {
              dataValue =
                cItem.nodeNameList?.data.length > 0
                  ? cItem.nodeNameList.data.find((x) => x.value === cItem.node_key?.value)?.value
                  : cItem.Node_Name || "";
            } else {
              dataValue =
                cItem.nodeNameList?.data.length > 0
                  ? cItem.nodeNameList.data.find((x) => x.value === cItem.node_key?.value)?.value
                  : cItem.node_key === 0
                    ? cItem.Node_Name || ""
                    : cItem.node_key;
            }
          } else if (item.data_type_name.toLowerCase() === "number") {
            dataValue = cItem[item.custom_col_name] ?? 0; // Default to 0 if null or empty
          } else if (item.custom_col_name === "period_name") {
            dataValue =
              periodNameListData?.length > 0
                ? periodNameListData.find((x) => x.text == cItem.period_name)?.value.toString() || cItem.period_name
                : cItem.period_name || "";
          } else {
            dataValue = cItem[item.custom_col_name];
          }

          // Ensure "0000-00-00 00:00:00" is treated as null
          if (dataValue === "0000-00-00 00:00:00") {
            dataValue = null;
          }

          obj.in_data_value = dataValue && typeof dataValue === "string" ? dataValue.trim() : dataValue;

          // Add object to row array
          rowArray.push(obj);
          //}
        });

        // Push the row's custom column data as an array inside updatedDataList
        updatedDataList.unshift(rowArray);
      });

      updatedDataList = updatedDataList
        .map((innerArray) =>
          [...innerArray].sort(
            (a, b) => normalizeOrder(a.in_custom_data_order) - normalizeOrder(b.in_custom_data_order)
          )
        )
        .sort((a, b) => normalizeOrder(a[0]?.in_custom_data_order) - normalizeOrder(b[0]?.in_custom_data_order));
      const bodyData = {
        insertUpdateArray: [...updatedDataList],
      };

      if (updatedDataList.length > 0) {
        setRefreshLoading(true);
        let response = await Action.addUpdateDataAsync(bodyData);
        if (response.success) {
          setRefreshLoading(false);
          dispatch(
            setUnSavedChangesPopup({
              ...unsavedPopup,
              isUnSavedChange: false,
            })
          );
          data.map((item) => {
            item.inEdit = false;
            return 0;
          });

          changeUpdateBtnState("disable", "grid-incell-update-" + versionData.custom_table_mstr_key);

          changeUpdateBtnState("disable", "grid-incell-cancel-" + versionData.custom_table_mstr_key);
          setSelectedState({});
          await onRefreshBtnClick();
          setDeleteSelectedIds([]);
          setSelectedRowId("");
          setCustomTableDataAddUpdate(false);
        } else {
          if (response.success === false && response.error_key === "duplicate") {
            setSelectedState({});
            await onRefreshBtnClick();
            setDeleteSelectedIds([]);
            setSelectedRowId("");
          } else {
            setRefreshLoading(false);
          }
        }
      }
    } else {
      changeCancelBtnState("enable", "grid-incell-cancel-" + versionData.custom_table_mstr_key);
      changeUpdateBtnState("enable", "grid-incell-update-" + versionData.custom_table_mstr_key);
    }
  };


  const remove = (ids) => {
    const visibleSelectedCount = deleteSelectedIds.filter((item) =>
      data.some(
        (row) => Number(row.custom_data_order) === Number(item.id)
      )
    ).length;

    let count = visibleSelectedCount
    // if (filterData.isFilter) {
    //   count = visibleSelectedCount
    // } else {
    //   count = deleteSelectedIds.length;
    // }


    setConfirmationPopup({
      ...confirmationPopup,
      isVisible: true,
      desc: count > 0 ? `Are you sure you want to delete <b>${count}</b> selected ${count === 1 ? 'row' : 'rows'}?` : 'Are you sure you want to delete selected row ?',
      type: "DELETE_CONFIRM",
      actionBtn: DELETE_BTN_ACTIONS(onCancelConfirm, onDeleteConfirm),
      data: [],
      action: "Delete",
    });
  };

  const onDeleteConfirm = (event) => {
    let clientDelete = false;
    const deleteArray = deleteSelectedIds.map((obj2) => {
      if (obj2.id > 0) {
        const idx = data.findIndex((elem) => elem.custom_data_order === Number(obj2.id));

        // let previousTierId = 0;
        // if (idx > 0) {
        //   previousTierId = data[idx - 1].custom_data_order;
        // }
        const obj1 = data[idx];
        if (obj1) {
          return {
            id: obj2?.id,
            in_date_version: obj1?.date_version,
          };
        } else {
          clientDelete = true;
          return {};
        }
      } else {
        clientDelete = true;
        return {};
      }
    });

    var serverDeleteArray = deleteArray.filter((value) => Object.keys(value).length !== 0);

    if (clientDelete === true) {
      // originalData.shift();
      // setData(originalData);
      const selectedIds = deleteSelectedIds.map((item) => Number(item.id));

      const updatedData = data.filter(
        (item) => !selectedIds.includes(Number(item.custom_data_order))
      );

      setData(updatedData);
      setGridData(updatedData)
      setErrorObj({});
      setConfirmationPopup({
        ...confirmationPopup,
        isVisible: false,
      });
      setSelectedRowId("");
      setDeleteSelectedIds([]);
      if (updatedData.length === 0) {
        changeCancelBtnState("disable", "grid-incell-cancel-" + versionData.custom_table_mstr_key);
        changeUpdateBtnState("disable", "grid-incell-update-" + versionData.custom_table_mstr_key);
      }

      if (updatedData.filter((x) => x.isAdd === true).length === 0) {
        changeCancelBtnState(
          "disable",
          "grid-incell-cancel-" + versionData.custom_table_mstr_key
        );
        changeUpdateBtnState(
          "disable",
          "grid-incell-update-" + versionData.custom_table_mstr_key
        );
      }
    }

    if (serverDeleteArray.length > 0) {
      let deleteData = {
        in_user_id: cookiesData.out_user_id,
        in_tenant_id: cookiesData.out_tenant_id,
        in_custom_data_order: serverDeleteArray,
        in_custom_table_mstr_key: versionData.custom_table_mstr_key,
      };
      setConfirmationPopup({
        ...confirmationPopup,
        isVisible: false,
        type: "",
        actionBtn: [],
        data: {},
        action: "",
      });
      setDeleteSelectedIds([]);
      setSelectedState({})
      setSelectedRowId("")
      Action.deleteDataAsync(deleteData).then(function (result) {
        setErrorObj({});
        setCustomTableDataAddUpdate(false);
        changeCancelBtnState("disable", "grid-incell-cancel-" + versionData.custom_table_mstr_key);
        changeUpdateBtnState("disable", "grid-incell-update-" + versionData.custom_table_mstr_key);
      });
    }
    if (_ref.current) {
      const scrollableElement = _ref.current.querySelector(".k-grid-content");
      if (scrollableElement) {
        scrollableElement.scrollTop = 0;
      }
    }
  };


  const setNewSelectedRow = (newState, isReset) => {
    setSelectedState(newState);
    let tempArray = [];

    const keys = Object.keys(newState).filter((key) => newState[key] === true);

    keys.map((item) => {
      let obj = {};
      obj.id = Number(item);
      // obj.text = item.event_group_name;
      tempArray.push(obj);
      return 0;
    });
    setSelectedRowId(tempArray[0]?.id);
    setDeleteSelectedIds(tempArray);
    if (isReset) {
      originalData.map((item) => {
        item.inEdit = false;
        item.selected = Number(item.custom_data_order) === Number(keys[0]);
        return 0;
      });
      setData(originalData);
    }
  };

  const onSelectionChange = (event) => {
    const newSelectedState = getSelectedState({
      event,
      selectedState: selectedState,
      dataItemKey: DATA_ITEM_KEY,
    });
    setNewSelectedRow(newSelectedState, false, selectedState);
  };

  const onCancelConfirm = (action) => {
    setConfirmationPopup({
      ...confirmationPopup,
      isVisible: false,
      type: "",
      actionBtn: [],
      data: {},
      action: "",
    });
    data.map((item) => {
      item.selected = false;
      return 0;
    });
    setData([...data]);

    // TODO : UNSAVED CHANGES
    // dispatch(
    //   setUnSavedChangesPopup({ ...unsavedPopup, isUnSavedChange: false })
    // );
  };

  const onRowClick = (dataItem) => {
    let newData = data.map((item) => ({
      ...item,
      selected: item.custom_data_order === dataItem.custom_data_order ? true : false,
      in_filter: `AND a.period_start_date <= '${selectedVersion?.period_end_date}' AND a.period_end_date >= '${selectedVersion?.period_start_date}'`,
    }));
    setData(newData);
    setSelectedRowId(dataItem.custom_data_order);
  };

  const enterEdit = (dataItem, field) => {
    if (pageProps.writeAccess === 0 || versionData.data_write_access === 0) {
      return false;
    }
    changeCancelBtnState("enable", `grid-incell-cancel-${versionData.custom_table_mstr_key}`);
    let newData = data.map((item) => ({
      ...item,
      inEdit: item.custom_data_order === dataItem.custom_data_order ? field : undefined,
    }));
    setSelectedField(true);
    let findIndex = data.findIndex((x) => x.custom_data_order === dataItem.custom_data_order);
    let listData = { data: [], loadingState: false };
    if (findIndex > -1) {
      listData.data = data[findIndex].nodeNameList.data;
    }

    if (versionData.custom_table_type === "H") {
      if (field === "Node_Name" && listData?.data && listData?.data.length === 0) {
        // setNodeNameList({ data: [], loadingState: false });
        if (dataItem.Node.toLowerCase() !== "plan") {
          getNodeNames(dataItem?.Node?.toLowerCase(), findIndex, dataItem, field);
        }
      }
    }
    setData(newData);
  };

  const itemChange = React.useCallback(
    (event) => {
      const field = event.field || "";
      setCustomTableDataAddUpdate(true);
      let requireMsg = event.field + "_msg";
      let uniqueValueValid =
        field === "Node" && versionData.custom_table_type === "H"
          ? "Node_Name" + event.dataItem.rowId
          : field + event.dataItem.rowId;
      let newData = [];
      if (versionData.custom_table_type === "S") {
        newData = data.map((item) =>
          item.custom_data_order === event.dataItem.custom_data_order
            ? {
              ...item,
              [field]: event.value,
              inIteamEdit: true,
              custom_table_mstr_key: versionData.custom_table_mstr_key,
              [uniqueValueValid]: "",
              [requireMsg]: event.dataItem[requireMsg],
            }
            : item
        );
      } else {
        newData = data.map((item) =>
          item.custom_data_order === event.dataItem.custom_data_order
            ? {
              ...item,
              [field]: event.value,
              inIteamEdit: true,
              Node_Name:
                field === "Node"
                  ? ""
                  : field === "Node_Name" || field == "node_key"
                    ? event?.value?.text
                    : item.Node_Name,
              [requireMsg]:
                field === "Node"
                  ? event.value !== ""
                    ? ""
                    : event.dataItem[requireMsg]
                  : field === "Node_Name" || field == "node_key"
                    ? event?.value?.text !== ""
                      ? ""
                      : event.dataItem[requireMsg]
                    : field === "Node_Name" || field == "node_key"
                      ? event?.value?.text !== ""
                        ? ""
                        : event.dataItem[requireMsg]
                      : event.dataItem[requireMsg],
                nodeNameList: {
                  data: field === "Node" && item.Node !== event.value ? [] : event.dataItem.nodeNameList.data,
                  loadingState:
                    field === "Node_Name" ? true : field === "Node" ? false : event.dataItem.nodeNameList.loadingState,
                },
                custom_table_mstr_key: versionData.custom_table_mstr_key,
                [uniqueValueValid]: "",
              }
            : {
                ...item,
                in_filter: `AND a.period_start_date <= '${selectedVersion?.period_end_date}' AND a.period_end_date >= '${selectedVersion?.period_start_date}'`,
              }
        );
      }

      let editItem = event.dataItem;
      editItem[field] = event.value;
      setData(newData);
      setGridData(newData.slice(pageData.skip, pageData.skip + pageData.take));
      changeCancelBtnState("enable", "grid-incell-cancel-" + versionData.custom_table_mstr_key);
      changeUpdateBtnState("enable", "grid-incell-update-" + versionData.custom_table_mstr_key);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data]
  );

  const setPageMenuState = (response) => {
    if (!deleteSelectedIds.length) {
      return false;
    }

    let ids = response.map((el) => el.custom_data_order);

    let selectedKeys = [];
    let tempArray = [];
    let tempArrayData = [];

    Object.keys(selectedState).map((item) => {
      let obj = {};

      obj.id = Number(item);
      selectedKeys.push(item);
      tempArray.push(obj);

      return 0;
    });

    ids.map((item) => {
      if (selectedKeys.includes(item.toString())) {
        tempArrayData.push(item);
      }
      return 0;
    });

    let strSelectedKeys = "";

    if (tempArrayData.length > 0) {
      strSelectedKeys = parseInt(selectedKeys[0]);
    }
    setSelectedRowId(strSelectedKeys);
  };

  const handlePageChange = async (event) => {
    const pageData = event.page;
    const vskip = pageData.skip;
    const vtake = pageData.take;
    if (event.syntheticEvent.target.props !== undefined) {
      setAPICallingState(true);
      if (isSelectedField) {
        setSelectedState({});
      }
      // setPage({ skip: pageData.skip, take: pageData.take });

      const dataVal = {
        ...apiCallData,
        in_filter: getInFilter(),
        in_sort_number: getInSortNumber(),
        in_sort_order: getInSortOrder(),
        in_page_row_offset: pageData.skip,
        in_page_rows: pageData.take,
        in_is_audit_log: 0,
      };
      if (searchData.in_data_filter !== "") {
        dataVal.in_data_filter = searchData.in_data_filter;
        dataVal.in_data_filter_count = searchData.in_data_filter_count;
      }
      setisPageApplied(true);
      setPagevs({ skip: vskip, take: vtake });
      await getGridCustomRowData(dataVal);
      changeCancelBtnState("disable", "grid-incell-cancel-" + versionData.custom_table_mstr_key);
      changeUpdateBtnState("disable", "grid-incell-update-" + versionData.custom_table_mstr_key);

      if (_ref.current) {
        const scrollableElement = _ref.current.querySelector(".k-grid-content");
        if (scrollableElement) {
          scrollableElement.scrollTop = 0;
        }
      }
    } else {
      setPage({ skip: vskip, take: vtake });
      setGridData(data.slice(vskip, vskip + vtake));
    }
    setCustomTableDataAddUpdate(false);
  };

  const handleColumnMenu = async (columnMenuData, isFilter, isSort, filterObj) => {
    let index = 1;
    let filterSkip = getPageSkip();
    let filterTake = getPageTake();

    if (isFilter) {
      filterSkip = 0;
      filterTake = pageSize.recordTake;

      //reset pager when filter applies
      setPage({ skip: filterSkip, take: filterTake });
      setPagevs({ skip: filterSkip, take: filterTake });
    }

    let sortOriginField = "";

    if (data.length > 0 && columnMenuData[0] !== undefined) {
      let obj = Object.keys(data[0]);
      let sortNameField = "";

      //replace mstr key with name field only when sorting is applied
      if (columnMenuData[0].field && columnMenuData[0].field.indexOf("_mstr_key")) {
        let sortKeyField = columnMenuData[0].field;
        sortNameField = sortKeyField.replace("_mstr_key", "_name");
      }

      sortOriginField = sortNameField !== "" ? sortNameField : columnMenuData[0].field;

      let sortObjKeys = obj.filter(
        (key) =>
          key !== "inIteamEdit" && key !== "isAdd" && key !== "nodeNameList" && key !== "selected" && key !== "rowId"
      );
      index = sortObjKeys.findIndex((x) => x === sortOriginField) + 1;
    }

    const filterString = isFilter ? getfilterDataString(columnMenuData, gridColumns) : filterData.data;

    isFilter = false;
    if (filterString !== "") {
      isFilter = true;
    }

    let sortDir = filterData.isSort && columnMenuData.length ? filterData.sort_order : DEFAULT_SORT.order;
    let sortNumber = filterData.isSort && columnMenuData.length ? filterData.in_sort_number : DEFAULT_SORT.number;

    isSort = !columnMenuData.length ? false : filterData.isSort;

    if (columnMenuData[0] !== undefined && columnMenuData[0].dir !== undefined) {
      isSort = true;
      sortDir = columnMenuData[0].dir.toUpperCase();
      sortNumber = index;
    }

    const dataVal = {
      ...apiCallData,
      in_filter: isFilter ? filterString : null,
      in_sort_number: sortNumber,
      in_sort_order: sortDir,
      in_page_row_offset: filterSkip,
      in_page_rows: filterTake,
      in_is_audit_log: 0,
    };
    setFilterData({
      ...filterData,
      isFilter: isFilter,
      isSort: isSort,
      data: filterString,
      in_sort_number: sortNumber,
      sort_order: sortDir,
    });

    setAPICallingState(true);

    if (searchData.in_data_filter !== "") {
      dataVal.in_data_filter = searchData.in_data_filter;
      dataVal.in_data_filter_count = searchData.in_data_filter_count;
    }

    await getGridCustomRowData(dataVal);
    changeCancelBtnState("disable", "grid-incell-cancel-" + versionData.custom_table_mstr_key);
    changeUpdateBtnState("disable", "grid-incell-update-" + versionData.custom_table_mstr_key);
    if (_ref.current) {
      const scrollableElement = _ref.current.querySelector(".k-grid-content");
      if (scrollableElement) {
        scrollableElement.scrollTop = 0;
      }
    }
    setCustomTableDataAddUpdate(false);
  };

  const updateEnableButtonState = () => {
    changeCancelBtnState("enable", "grid-incell-cancel-" + versionData.custom_table_mstr_key);
    changeUpdateBtnState("enable", "grid-incell-update-" + versionData.custom_table_mstr_key);
  };

  const NumberCell = React.useCallback(
    (props) => {
      const { ariaColumnIndex, columnIndex, dataItem, field, render } = props;
      let isInEdit = field === dataItem.inEdit;
      let value = props.field + dataItem.rowId;
      let requiredMsgVal = props.field + "_msg";
      const handleChange = (e, props, value) => {
        if (props.onChange) {
          // TODO : UNSAVED CHANGES
          // dispatch(setUnSavedChangesPopup({ isUnSavedChange: true }));
          updateEnableButtonState();
          props.onChange({
            // dataIndex: 0,
            dataItem: props.dataItem,
            field: props.field,
            syntheticEvent: e.syntheticEvent,
            value: e.target.value,
          });
        }
      };

      const defaultRendering = (
        <td aria-colindex={ariaColumnIndex} data-grid-col-index={columnIndex}>
          {isInEdit ? (
            <NumericTextBox
              value={dataItem[field] ? applyFormat(dataItem[field], "") : dataItem[field]}
              format={"#.########"} // Allows up to 8 decimal places
              onChange={(e) => {
                changeUpdateBtnState("enable", "grid-incell-update-" + versionData.custom_table_mstr_key);
                handleChange(e, props, value);
              }}
              className="table-input"
              name={`${field}`}
            />
          ) : (
            <LoadingCell props={props} val={formatUnitValue(props.dataItem[props.field || ""], props.format)} />
          )}
          <div role="alert" className="k-form-error k-text-start text-wrap custom-table-data-err-msg">
            {dataItem[requiredMsgVal]}
          </div>
        </td>
      );
      return render?.call(undefined, defaultRendering, props);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data]
  );

  const DateCell = React.useCallback(
    (props) => {
      const { ariaColumnIndex, columnIndex, dataItem, field, render } = props;
      let isInEdit = field === dataItem.inEdit;

      let value = props.field + dataItem.rowId;
      let requiredMsgVal = props.field + "_msg";
      const handleChange = (e, props, value) => {
        if (props.onChange) {
          updateEnableButtonState();
          props.onChange({
            // dataIndex: 0,
            dataItem: props.dataItem,
            field: props.field,
            syntheticEvent: e.syntheticEvent,
            value: e.value,
          });
        }
      };
      if (dataItem[field] === "0000-00-00 00:00:00") {
        dataItem[field] = null;
      } else {
        dataItem[field] = typeof dataItem[field] === "string" ? dataItem[field].replace("Z", "0") : dataItem[field];
      }

      const defaultRendering = (
        <td aria-colindex={ariaColumnIndex} data-grid-col-index={columnIndex}>
          {isInEdit ? (
            <DatePicker
              value={dataItem[field] !== null && dataItem[field] !== "" ? new Date(dataItem[field]) : dataItem[field]}
              onChange={(e) => {
                changeUpdateBtnState("enable", "grid-incell-update-" + versionData.custom_table_mstr_key);
                handleChange(e, props, value);
              }}
              className="table-input"
              name={`${field}`}
              toggleButton={CustomToggleButton}
              formatPlaceholder={{
                month: "mm",
                day: "dd",
                year: "yyyy",
              }}
              format="MM/dd/yyyy"
            />
          ) : props.dataItem[props.field] === null ? (
            ""
          ) : (
            <LoadingCell
              props={props}
              val={transformDateTime({
                date: props.dataItem[props.field],
                format: "MM/DD/YYYY",
              })}
            />
          )}
          <div role="alert" className="k-form-error k-text-start text-wrap custom-table-data-err-msg">
            {dataItem[requiredMsgVal]}
          </div>
        </td>
      );
      return render?.call(undefined, defaultRendering, props);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data]
  );

  const BooleanCell = React.useCallback(
    (props) => {
      const { ariaColumnIndex, columnIndex, dataItem, field, render } = props;
      let isInEdit = field === dataItem.inEdit;

      let value = props.field + dataItem.rowId;
      let requiredMsgVal = props.field + "_msg";
      const handleChange = (e, props, value) => {
        if (props.onChange) {
          // TODO : UNSAVED CHANGES

          //dispatch(setUnSavedChangesPopup({ isUnSavedChange: true }));
          updateEnableButtonState();
          props.onChange({
            // dataIndex: 0,
            dataItem: props.dataItem,
            field: props.field,
            syntheticEvent: e.syntheticEvent,
            value: e.target.value ? 1 : 0,
          });
        }
      };

      let val = props.dataItem[props.field] !== "" ? (props.dataItem[props.field] === 1 ? "true" : "false") : "";
      const defaultRendering = (
        <td aria-colindex={ariaColumnIndex} data-grid-col-index={columnIndex}>
          {isInEdit ? (
            <Checkbox
              value={dataItem[field]}
              checked={dataItem[props.field]}
              onChange={(e) => {
                changeUpdateBtnState("enable", "grid-incell-update-" + versionData.custom_table_mstr_key);
                handleChange(e, props, value);
              }}
              className="table-input"
              name={`${field}`}
            />
          ) : (
            // <span title={val}>{val}</span>
            <LoadingCell props={props} val={val} />
          )}
          <div role="alert" className="k-form-error k-text-start text-wrap custom-table-data-err-msg">
            {dataItem[requiredMsgVal]}
          </div>
        </td>
      );
      return render?.call(undefined, defaultRendering, props);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [errorObj]
  );

  useEffect(() => {
    if(versionData.custom_table_type === "H" && selectedVersion?.period_end_date && selectedVersion?.period_start_date){
      getPeriodsDataListForGrid();
    }
  }, [selectedVersion,versionData]);


  const getPeriodsDataListForGrid = async () => {

    let periodsDataReq = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_filter: `AND a.period_start_date <= '${selectedVersion?.period_end_date}' AND a.period_end_date >= '${selectedVersion?.period_start_date}'`,
      in_sort_number: 10,
      in_sort_order: null,
      in_page_row_offset: 0,
      in_page_rows: 9999,
      //  in_sort_number_concat: 'a.period_end_date DESC, a.period_level_order DESC',
      in_sort_number_concat: "a.period_end_date ASC, a.period_level_order DESC",
    };
    let resPeriods = await GetPeriodsDataList(periodsDataReq, dispatch, history);
    if (resPeriods.length > 0) {
      let tempArray = [];
      resPeriods.map((item) => {
        let obj = {};
        obj.text = item.period_name;
        obj.id = item.period_mstr_key;
        obj.in_period_start_date = item.period_start_date;
        obj.in_period_end_date = item.period_end_date;
        obj.value = item.period_mstr_key;
        tempArray.push(obj);
        return 0;
      });

      setPeriodNameListGrid(tempArray);
    } else {
    }
  };


  const PeriodNameCell = React.useCallback(
    (props) => <PeriodNameDropDownCell {...props}  periodNameListDataValue={periodNameListGrid} />,
    [periodNameListGrid]
  );

  const useCol = React.useCallback(
    (columns) => {
      return columns.map((column, idx) => {
        return column.show && column.title !== "" ? (
          <Column
            {...columnMenuProps(column, "custom_table_rows")}
            key={idx}
            cell={
              column.type === "number"
                ? NumberCell
                : column.type === "date"
                  ? DateCell
                  : column.type === "boolean"
                    ? BooleanCell
                    : column.field === "Node" && versionData.custom_table_type === "H"
                      ? DropDownCell
                      : column.field === "period_name" &&
                          customTableColumns.some((val) => val.custom_col_name == "period_name" && val.ref_mstr_key)
                        ? PeriodNameCell
                        : column.field === "Node_Name" && versionData.custom_table_type === "H"
                          ? NodeNameDropdownCell
                          : NameCell
            }
            sortable={true}
            width={column.min_width}
            format={column.format}
          />
        ) : (
          false
        );
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [customTableColumns, PeriodNameCell]
  );

  let GroupColumn = useCol(gridColumns);

  const onClearFilter = async () => {
    setAPICallingState(true);
    //set in_params
    const dataVal = {
      ...apiCallData,
      in_filter: null,
      in_sort_number: getInSortNumber(),
      in_sort_order: getInSortOrder(),
      in_page_row_offset: getPageSkip(),
      in_page_rows: getPageTake(),
      in_is_audit_log: 0,
    };
    if (searchData.in_data_filter !== "") {
      dataVal.in_data_filter = searchData.in_data_filter;
      dataVal.in_data_filter_count = searchData.in_data_filter_count;
    }
    //set filter to false
    setFilterData({
      ...filterData,
      data: "",
      isFilter: false,
    });

    getGridCustomRowData(dataVal);
    if (_ref.current) {
      const scrollableElement = _ref.current.querySelector(".k-grid-content");
      if (scrollableElement) {
        scrollableElement.scrollTop = 0;
      }
    }
  };

  const getGridCustomRowData = async (dataVal) => {
    setErrorObj({});
    let response = await Action.getListDataAsync(dataVal);
    setDataRowsCount(response.dataCount);
    if (response.rateTierData.length > 0) {
      setData(response.rateTierData);
      setOriginalData(response.rateTierData);
      setPageMenuState(response.rateTierData);
      setAPICallingState(false);
    } else {
      setPageMenuState(response.rateTierData);
      return false;
    }
  };

  const onRefreshBtnClick = async () => {
    setAPICallingState(true);
    setErrorObj({});
    const dataVal = {
      ...apiCallData,
      in_filter: getInFilter(),
      in_sort_number: getInSortNumber(),
      in_sort_order: getInSortOrder(),
      in_page_row_offset: getPageSkip(),
      in_page_rows: getPageTake(),
      in_data_filter: null,
      in_data_filter_count: 0,
      in_is_audit_log: 0,
    };
    if (searchData.in_data_filter !== "") {
      dataVal.in_data_filter = searchData.in_data_filter;
      dataVal.in_data_filter_count = searchData.in_data_filter_count;
    }
    await getGridCustomRowData(dataVal);
    changeCancelBtnState("disable", "grid-incell-cancel-" + versionData.custom_table_mstr_key);
    changeUpdateBtnState("disable", "grid-incell-update-" + versionData.custom_table_mstr_key);
    if (_ref.current) {
      const scrollableElement = _ref.current.querySelector(".k-grid-content");
      if (scrollableElement) {
        const currentScrollPosition = scrollableElement.scrollTop;

        setTimeout(() => {
          scrollableElement.scrollTop = currentScrollPosition;
        }, 0); // Ensure DOM updates are complete
      }
    }
    setCustomTableDataAddUpdate(false);
  };

  const onRefreshClick = async () => {
    setAPICallingState(true);
    setErrorObj({});
    if (searchData.in_data_filter === "" && isSearchBtnClick === false) {
      const dataVal = {
        ...apiCallData,
        in_filter: getInFilter(),
        in_sort_number: getInSortNumber(),
        in_sort_order: getInSortOrder(),
        in_page_row_offset: 0,
        in_page_rows: pageDatavs.take,
        in_data_filter: null,
        in_data_filter_count: 0,
        in_is_audit_log: 0,
      };
      if (searchData.in_data_filter !== "") {
        dataVal.in_data_filter = searchData.in_data_filter;
        dataVal.in_data_filter_count = searchData.in_data_filter_count;
      }
      await getGridCustomRowData(dataVal);
      changeCancelBtnState("disable", "grid-incell-cancel-" + versionData.custom_table_mstr_key);
      changeUpdateBtnState("disable", "grid-incell-update-" + versionData.custom_table_mstr_key);
    } else {
      const dataVal = {
        ...apiCallData,
        in_filter: getInFilter(),
        in_sort_number: getInSortNumber(),
        in_sort_order: getInSortOrder(),
        in_page_row_offset: 0,
        in_page_rows: pageDatavs.take,
        in_is_audit_log: 0,
      };
      if (searchData.in_data_filter !== "") {
        dataVal.in_data_filter = searchData.in_data_filter;
        dataVal.in_data_filter_count = searchData.in_data_filter_count;

        await getGridCustomRowData(dataVal);
      } else {
        if (isSearchBtnClick === true) {
          await getGridCustomRowData(dataVal);
        } else {
          dataVal.in_data_filter = null;
          dataVal.in_data_filter_count = 0;
          await Action.getCustomTableListDataAsync(dataVal);
        }
      }
      changeCancelBtnState("disable", "grid-incell-cancel-" + versionData.custom_table_mstr_key);
      changeUpdateBtnState("disable", "grid-incell-update-" + versionData.custom_table_mstr_key);
    }
    setCustomTableDataAddUpdate(false);
  };

  const exitEdit = (dataItem, index, dataIndex, e) => {
    if (dataItem.rate_table_tier_name === "") {
      handleValidation();
    }
  };

  const customRowRender = (tr, props) => (
    <RowRender originalProps={props} tr={tr} editField={editFieldTier} exitEdit={exitEdit} />
  );

  const getExportData = async () => {
    setExportData([]);
    const dataVal = {
      ...apiCallData,
      in_page_row_offset: 0,
      in_page_rows: dataRowsCount,
      in_filter: getInFilter(),
      in_sort_number: getInSortNumber(),
      in_sort_order: getInSortOrder(),
    };

    if (searchData.in_data_filter !== "") {
      dataVal.in_data_filter = searchData.in_data_filter;
      dataVal.in_data_filter_count = searchData.in_data_filter_count;
    }

    let res = await Action.exportDataAsync(dataVal);
    if (res.length > 0) {
      res.map((cItem, i) => {
        customTableColumns.forEach((item) => {
          if (item.data_type_name.toLowerCase() === "date") {
            if (cItem[item.custom_col_name] !== "0000-00-00 00:00:00") {
              cItem[item.custom_col_name] = new Date(
                applyDateFormat(cItem[item.custom_col_name], "{0:MM/dd/yyyy HH:mm:ss}")
              );
            } else {
              cItem[item.custom_col_name] = "";
            }
          }

          if (item.data_type_name.toLowerCase() === "boolean") {
            cItem[item.custom_col_name] = cItem[item.custom_col_name] ? "true" : "false";
          }
          return 0;
        });
        return 0;
      });

      setExportData(res);
    }
  };

  const customCellRender = (td, props) => {
    return (
      <CellRender
        navigatable={true}
        originalProps={props}
        td={td}
        enterEdit={enterEdit}
        editField={editFieldTier}
        onRowClick={onRowClick}
      />
    );
  };

  const CustomToggleButton = (props) => {
    return (
      <Tooltip
        position="bottom"
        anchorElement="target"
        style={{
          paddingTop: 10,
        }}
      >
        <ToggleButton {...props} title="Calendar">
          <span className="k-icon k-font-icon k-i-calendar" title="Calendar" />
        </ToggleButton>
      </Tooltip>
    );
  };

  const onSearchBtnClick = async () => {
    setResetSort(true);
    setFilterData({
      ...filterData,
      data: "",
      isFilter: false,
    });
    setData([]);
    setPageSize(defaultPageSizevs);
    setPage({
      skip: 0,
      take: defaultPageSize.recordTake,
    });
    setPagevs({
      skip: 0,
      take: defaultPageSizevs.recordTake,
    });
    setDataRowsCount(0);
    setDeleteSelectedIds([]);
    setSelectedState({});
    setSelectedRowId("");
    let filterCount = 0;
    let filterDataString = "";
    customTableColumnsDropDown
      .filter((x) => x.custom_col_is_key === 1)
      .map((item) => {
        if (item.valueData && typeof item.valueData === "object" && !Array.isArray(item.valueData)) {
          if (item.data_type_name.toLowerCase() === 'date' && typeof item.valueData === "object") {
            filterCount++;
          }
          if (item.valueData.text && item.valueData.text !== "Select All") {
            filterCount++;
          }
        } else if (item.valueData && item.valueData?.length > 0) {
          if (item.valueData[0] && item.valueData[0].data_value !== "Select All") {
            filterCount++;
          }
        } else if (typeof item.valueData === "date") {
          filterCount++;
        }
      });
    let filterColumnNames = [];
    let filterColumnData = [];
    if (filterCount > 0) {
      let isCheckBoolean = customTableColumnsDropDown.filter(
        (x) => x.data_type_name.toLowerCase() === "boolean" && x.custom_col_is_key === 1
      );

      let isDateFieldCheck = customTableColumnsDropDown.filter(
        (x) => x.data_type_name.toLowerCase() === "date" && x.custom_col_is_key === 1
      );

      // For boolean fields
      const booleanColumns = customTableColumnsDropDown
        .filter(
          (x) =>
            x.data_type_name?.toLowerCase() === "boolean" &&
            x.valueData &&
            typeof x.valueData === "object" &&
            !Array.isArray(x.valueData) &&
            Object.keys(x.valueData).length > 0 &&
            x.valueData.text !== "Select All"
        )
        .map((x) => x.origin_custom_col_name);

      // For date fields
      const dateColumns = customTableColumnsDropDown
        .filter((x) => x.data_type_name?.toLowerCase() === "date" && x.valueData && typeof x.valueData === "object")
        .map((x) => x.origin_custom_col_name);

      // For other fields (multi-select etc.)
      const otherColumns = customTableColumnsDropDown
        .filter((x) => Array.isArray(x.valueData) && x.valueData.length > 0 && x.valueData.text !== "Select All")
        .map((x) => x.origin_custom_col_name);

      // Merge all column names (avoid duplicates)
      filterColumnNames = Array.from(new Set([...booleanColumns, ...dateColumns, ...otherColumns]));

      // Boolean values
      const booleanValues = customTableColumnsDropDown
        .filter(
          (x) =>
            x.data_type_name?.toLowerCase() === "boolean" &&
            x.custom_col_is_key === 1 &&
            x.valueData &&
            typeof x.valueData === "object" &&
            !Array.isArray(x.valueData) &&
            Object.keys(x.valueData).length > 0 &&
            x.valueData.text !== "Select All"
        )
        .map((x) => x.valueData.value);

      // Date values
      const dateValues = customTableColumnsDropDown
        .filter(
          (x) =>
            x.data_type_name?.toLowerCase() === "date" &&
            x.custom_col_is_key === 1 &&
            x.valueData &&
            typeof x.valueData === "object"
        )
        .map((x) =>
          transformDateTime({
            date: x.valueData,
            format: "yyyy-MM-DD",
          })
        );

      // Other values (multi-select, etc.)
      const otherValues = customTableColumnsDropDown
        .filter((x) => Array.isArray(x.valueData) && x.valueData.length > 0 && x.valueData.text !== "Select All")
        .flatMap((x) => {
          if (x.custom_col_name === "Node_Name" && restProps.versionData.custom_table_type === "H") {
            return x.valueData.filter((x) => x.data_value !== "Select All").map((item) => item?.value || "");
          } else {
            return x.valueData
              .filter((x) => x.data_value !== "Select All")
              .map((item) => item?.data_value || item?.text);
          }
        });

      // Merge all values
      filterColumnData = [...booleanValues, ...dateValues, ...otherValues];
      const customColName = filterColumnNames.map((value) => `"${value}"`).join(", ");
      const formattedValues = filterColumnData.map((value) => `"${value}"`).join(", ");

      filterDataString = `AND (a.custom_col_name IN (${customColName})) AND (a.data_value IN (${formattedValues}))`;
    }
    setAPICallingState(true);
    setPageSize(defaultPageSizevs);
    setPage({
      skip: 0,
      take: defaultPageSize.recordTake,
    });
    setPagevs({
      skip: 0,
      take: defaultPageSizevs.recordTake,
    });
    if (periodFields?.periodValue?.text && periodFields?.periodValue?.text !== "Select All") {
      setFilterData({
        ...filterData,
        isFilter: true,
        data: ` AND ( a.period_name LIKE '%${periodFields.periodValue.text}%' ) `,
      });
    } else if (periodFields?.periodValue?.text && periodFields?.periodValue?.text == "Select All") {
    }
    const dataVal = {
      ...apiCallData,
      in_load_type: "grid-reload",
      in_filter:
        periodFields?.periodValue?.text == "Select All"
          ? null
          : periodFields?.periodValue?.text
            ? ` AND ( a.period_name LIKE '%${periodFields.periodValue.text}%' ) `
            : null,
      in_sort_number: DEFAULT_SORT.number,
      in_sort_order: DEFAULT_SORT.order,
      in_page_rows: defaultPageSizevs.recordTake,
      in_page_row_offset: 0,
      in_is_audit_log: 0,
    };
    if (filterColumnNames.length > 0 && filterColumnData.length > 0) {
      dataVal.in_data_filter = filterDataString;
      dataVal.in_data_filter_count = filterCount;
    }
    let res = await Action.getListDataAsync(dataVal);
    if (res) {
      // setGridColumns(res.rateTierColumn);
      // setColumnsData(res.rateTierColumn)
      // setColumns(res.rateTierColumn)
      setDataRowsCount(res.dataCount);
      setData(res.rateTierData);
      setOriginalData(res.rateTierData);
      setTierData(res);
    }
    setIsSearchBtnClick(true);

    setSearchData({
      in_data_filter: filterDataString,
      in_data_filter_count: filterCount,
    });
    setResetSort(false);
    changeCancelBtnState("disable", "grid-incell-cancel-" + versionData.custom_table_mstr_key);
    changeUpdateBtnState("disable", "grid-incell-update-" + versionData.custom_table_mstr_key);
  };

  const filterDropdownChangeValue = async (e, item) => {
    let dataIndex = customTableColumnsDropDown.findIndex((x) => x.custom_col_mstr_key === item.custom_col_mstr_key);
    let customTableColData = [...customTableColumnsDropDown];
    customTableColData[dataIndex].loading = true;
    customTableColData[dataIndex].filterValue = e.filter.value;
    setCustomTableColumnsDropDown([...customTableColData]);
    let value = e.filter.value;
    if (value) {
      let reqData = {
        in_tenant_id: cookiesData.out_tenant_id,
        in_user_key: cookiesData.out_user_id,
        in_custom_col_mstr_key: item.custom_col_mstr_key,
        in_date_version: selectedVersion.dateVersion,
        in_filter: `AND data_value LIKE '%${value}%'`,
        in_page_row_offset: 0,
        in_page_rows: 9999,
      };
      let res = await Action.getCustomTableColumnsData(reqData);
      if (res) {
        if (customTableColData[dataIndex].data_type_name.toLowerCase() === "number") {
          res.forEach((item) => {
            item.data_value = applyFormat(item.data_value);
          });
        }
        customTableColData[dataIndex].data = res;
        customTableColData[dataIndex].loading = false;
        setCustomTableColumnsDropDown([...customTableColData]);
      }
    } else {
      customTableColData[dataIndex].loading = false;
      setCustomTableColumnsDropDown([...customTableColData]);
    }
  };

  const handleChangeDropdownValue = (e, item) => {
    let dataIndex = customTableColumnsDropDown.findIndex((x) => x.custom_col_mstr_key === item.custom_col_mstr_key);
    let customTableColData = [...customTableColumnsDropDown];
    customTableColData[dataIndex].valueData = e.value;
    if (customTableColData[dataIndex].custom_col_name === "Node_Name" && versionData.custom_table_type === "H") {
      customTableColData[dataIndex].valueData = e.selectedValue;
      // customTableColData[dataIndex].valueData = []
    }
    if (customTableColData[dataIndex].custom_col_name === "Node" && versionData.custom_table_type === "H") {
      let findIndex = customTableColumnsDropDown.findIndex((x) => x.custom_col_name === "Node_Name");
      customTableColData[findIndex].valueData = [];
    }
    if (customTableColData[dataIndex].custom_col_name === "period_name" && versionData.custom_table_type === "H") {
      let findIndex = customTableColumnsDropDown.findIndex((x) => x.custom_col_name === "Node_Name");
      customTableColData[findIndex].valueData = [];
    }
    customTableColData[dataIndex].data = item.data_type_name.toLowerCase() === "boolean" ? BOOLEAN_DRP_DATA : item.data;

    setCustomTableColumnsDropDown([...customTableColData]);
  };

  const handleBlur = (item) => {
    let dataIndex = customTableColumnsDropDown.findIndex((x) => x.custom_col_mstr_key === item.custom_col_mstr_key);
    let customTableColData = [...customTableColumnsDropDown];
    customTableColData[dataIndex].filterValue = "";
    customTableColData[dataIndex].data = [];
    setCustomTableColumnsDropDown([...customTableColData]);
  };

  const listNoDataRender = (element) => {
    const noData = (
      <h4
        style={{
          fontSize: "1em",
        }}
      >
        <br />
        No data found
      </h4>
    );
    return React.cloneElement(element, { ...element.props }, noData);
  };

  const listTextRender = (element) => {
    const noData = (
      <h4
        style={{
          fontSize: "1em",
        }}
      >
        <br />
        ENTER TEXT FOR MATCHING FILTER VALUES
      </h4>
    );
    return React.cloneElement(element, { ...element.props }, noData);
  };

  React.useEffect(() => {
    const selobj = selectedState;
    if (
      (pageData.skip === 0 || filterData.isFilter || filterData.isSort || isPageApplied)
      &&
      Object.keys(selobj).length === 0
    ) {
      setGridData(data.slice(0, VIRTUAL_PAGE_SIZE));
      setisPageApplied(false);
      setSelectedField(false);
    } else {
      setGridData(data.slice(pageData.skip, pageData.skip + pageData.take));
    }
  }, [data]); // Runs only when changes

  const getNodeNamesForSearch = async (nodeName, item) => {
    let dataIndex = customTableColumnsDropDown.findIndex((x) => x.custom_col_mstr_key === item.custom_col_mstr_key);
    let customTableColData = [...customTableColumnsDropDown];
    switch (nodeName.value) {
      case "position":
        let dataObject = {
          in_tenant_id: cookiesData.out_tenant_id,
          in_filter: null,
          in_user_key: cookiesData.out_user_id,
          in_sort_number: 2,
          in_sort_order: "ASC",
          in_page_row_offset: 0,
          in_page_rows: 9999,
          in_acct_encrypt_key: cookiesData.out_acct_encrypt_key,
          in_user_role_filter: null,
          in_export_flag: 0,
          in_is_current_flag: 1,
        };
        let resDataObject = await GetPositionDataAPI(dataObject, history, dispatch);
        if (resDataObject && resDataObject.length) {
          const tempData = resDataObject
            .filter((x) => x.position_name !== "")
            .map((item) => ({
              text: item.position_name,
              value: item.org_position_key,
            }));

          setNodeNameFields({
            ...nodeNameFields,
            nodeNameValue: "",
            nodeNameList: tempData,
            isNodeNameLoading: false,
          });
          customTableColData[dataIndex].data = tempData;
          setCustomTableColumnsDropDown([...customTableColData]);
        } else {
          setNodeNameFields({
            ...nodeNameFields,
            nodeNameValue: "",
            nodeNameList: [],
            isNodeNameLoading: false,
          });
          customTableColData[dataIndex].data = [];
          setCustomTableColumnsDropDown([...customTableColData]);
        }
        break;
      case "team":
        let reqData = {
          in_tenant_id: cookiesData.out_tenant_id,
          in_eff_end_date: selectedVersion.endDate,
        };
        let res = await GetTeamNameApi(reqData, history, dispatch);
        if (res && res.length) {
          const tempData = res.map((item) => ({
            text: item.team_name,
            value: item.team_name,
          }));
          setNodeNameFields({
            ...nodeNameFields,
            nodeNameValue: "",
            nodeNameList: tempData,
            isNodeNameLoading: false,
          });
          customTableColData[dataIndex].data = tempData;
          setCustomTableColumnsDropDown([...customTableColData]);
        } else {
          setNodeNameFields({
            ...nodeNameFields,
            nodeNameValue: "",
            nodeNameList: [],
            isNodeNameLoading: false,
          });
          customTableColData[dataIndex].data = [];
          setCustomTableColumnsDropDown([...customTableColData]);
        }
        break;
      case "group":
        let dataValue = {
          in_tenant_id: cookiesData.out_tenant_id,
          in_filter: null,
          in_user_role_filter: null,
          in_sort_number: 3,
          in_sort_order: null,
          in_page_row_offset: 0,
          in_page_rows: 9999,
        };
        let resData = await GetGroupNameAPI(dataValue, history, dispatch);
        if (resData && resData.length) {
          const tempData = resData.map((item) => ({
            text: item.title_name,
            value: item.org_title_key,
          }));
          setNodeNameFields({
            ...nodeNameFields,
            nodeNameValue: "",
            nodeNameList: tempData,
            isNodeNameLoading: false,
          });
          customTableColData[dataIndex].data = tempData;
          setCustomTableColumnsDropDown([...customTableColData]);
        } else {
          setNodeNameFields({
            ...nodeNameFields,
            nodeNameValue: "",
            nodeNameList: [],
            isNodeNameLoading: false,
          });
          customTableColData[dataIndex].data = [];
          setCustomTableColumnsDropDown([...customTableColData]);
        }
        break;
      case "specialty":
        let dataObjValue = {
          in_user_key: cookiesData.out_user_id,
          in_tenant_id: cookiesData.out_tenant_id,
          in_filter: null,
          in_sort_number: 3,
          in_sort_order: "DESC",
          in_page_row_offset: 0,
          in_page_rows: 9999,
        };
        let resDataObjValue = await GetSPECIALTYAPI(dataObjValue, history, dispatch);
        if (resDataObjValue && resDataObjValue.length) {
          const tempData = resDataObjValue.map((item) => ({
            text: item.specialty_name,
            value: item.specialty_mstr_key,
          }));
          setNodeNameFields({
            ...nodeNameFields,
            nodeNameValue: "",
            nodeNameList: tempData,
            isNodeNameLoading: false,
          });
          customTableColData[dataIndex].data = tempData;
          setCustomTableColumnsDropDown([...customTableColData]);
        } else {
          setNodeNameFields({
            ...nodeNameFields,
            nodeNameValue: "",
            nodeNameList: [],
            isNodeNameLoading: false,
          });
          customTableColData[dataIndex].data = [];
          setCustomTableColumnsDropDown([...customTableColData]);
        }
        break;
      case "plan":
        let dataObj = {
          in_tenant_id: cookiesData.out_tenant_id,
          in_filter: null,
          in_sort_number: null,
          in_sort_order: null,
          in_user_key: cookiesData.out_user_id,
          in_multi_sort_order: null,
        };
        let resDataObj = await GetCompPlanDataApi(dataObj, history, dispatch);
        if (resDataObj && resDataObj.length) {
          const tempData = resDataObj.map((item) => ({
            text: item.comp_plan_name,
            value: item.comp_plan_mstr_key,
          }));
          setNodeNameFields({
            ...nodeNameFields,
            nodeNameValue: "",
            nodeNameList: tempData,
            isNodeNameLoading: false,
          });
          customTableColData[dataIndex].data = tempData;
          setCustomTableColumnsDropDown([...customTableColData]);
        } else {
          setNodeNameFields({
            ...nodeNameFields,
            nodeNameValue: "",
            nodeNameList: [],
            isNodeNameLoading: false,
          });
          customTableColData[dataIndex].data = [];
          setCustomTableColumnsDropDown([...customTableColData]);
        }
        break;
      default:
        break;
    }
  };

  const handleFilterChange = (dataVal, item) => {
    setNodeFields({
      ...nodeFields,
      modeList: dataVal,
    });
    let dataIndex = customTableColumnsDropDown.findIndex((x) => x.custom_col_mstr_key === item.custom_col_mstr_key);
    let customTableColData = [...customTableColumnsDropDown];
    customTableColData[dataIndex].data = dataVal;
    setCustomTableColumnsDropDown([...customTableColData]);
  };
  const [filterValue, setFilterValue] = React.useState("");

  const handleFilterChangePeriodName = (dataVal, item) => {
    setPeriodNameList(dataVal);
    setPeriodFields({
      ...periodFields,
      periodList: dataVal,
    });
    let dataIndex = customTableColumnsDropDown.findIndex((x) => x.custom_col_mstr_key === item.custom_col_mstr_key);
    let customTableColData = [...customTableColumnsDropDown];
    customTableColData[dataIndex].data = dataVal;
    setCustomTableColumnsDropDown([...customTableColData]);
  };

  const handleFilterChangeForNodeName = (dataValue, item) => {
    let dataIndex = customTableColumnsDropDown.findIndex((x) => x.custom_col_mstr_key === item.custom_col_mstr_key);
    let customTableColData = [...customTableColumnsDropDown];
    customTableColData[dataIndex].data = dataValue;
    setCustomTableColumnsDropDown([...customTableColData]);
  };

  const handleStageChange = async (e) => {
    setStateChange(e.state);

    if (e.state === "MINIMIZED") {
      if (_ref.current) {
        const scrollableElement = _ref.current.querySelector(".k-grid-content");
        if (scrollableElement) {
          setScrollTop(scrollableElement.scrollTop); // Save scroll position
        }
      }
      setModal(false);
    } else if (e.state === "DEFAULT") {
      setModal(true);
      setTimeout(() => {
        if (_ref.current) {
          const scrollableElement = _ref.current.querySelector(".k-grid-content");
          if (scrollableElement) {
            scrollableElement.scrollTop = scrollTop; // Restore scroll position
          }
        }
      }, 50);
      setTimeout(() => {
        setGridKey((prevKey) => prevKey + 1); // Update key after modal is restored
      }, 50); // Delay increased to ensure the DOM is fully updated
    }
  };

  const onClosePopup = () => {
    setModal(false);
    restProps.setOpenPopup(false);
  };

  const ModalTitle = () => {
    return (
      <>
        <span className="custtableflex">
          <div className="custtableitem">{versionData?.custom_table_name}</div>{" "}
          <span className="custtableseprator">&gt;</span> {`Custom Table Data Rows`}
        </span>
      </>
    );
  };

  const handleDateChange = (e, item) => {
    let dataIndex = customTableColumnsDropDown.findIndex((x) => x.custom_col_mstr_key === item.custom_col_mstr_key);
    let customTableColData = [...customTableColumnsDropDown];
    customTableColData[dataIndex].valueData = e.value;

    setCustomTableColumnsDropDown([...customTableColData]);
  };

  const getPeriodsDataList = async () => {
    let periodsDataReq = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_filter: "",
      in_sort_number: 10,
      in_sort_order: null,
      in_page_row_offset: 0,
      in_page_rows: 9999,
      in_sort_number_concat: "a.period_end_date ASC, a.period_level_order DESC",
    };
    let resPeriods = await GetPeriodsDataList(periodsDataReq, dispatch, history);
    if (resPeriods.length > 0) {
      let tempArray = [];
      resPeriods.map((item) => {
        let obj = {};
        obj.text = item.period_name;
        obj.id = item.period_mstr_key;
        obj.in_period_start_date = item.period_start_date;
        obj.in_period_end_date = item.period_end_date;
        obj.value = item.period_mstr_key;
        tempArray.push(obj);
        return 0;
      });
      setPeriodNameListData(tempArray);
    } else {
    }
  };

  useEffect(() => {
    if(versionData.data_filter_access === 1){
      getPeriodsDataLists();
    }
  }, [changeVersion ,versionData]);

  const getPeriodsDataLists = async () => {
    // if (!in_filter) {
    //   return;
    // }
    let periodsDataReq = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_filter: `AND a.period_start_date <= '${selectedVersion?.period_end_date}' AND a.period_end_date >= '${selectedVersion?.period_start_date}'`,
      in_sort_number: 10,
      in_sort_order: null,
      in_page_row_offset: 0,
      in_page_rows: 9999,
      //  in_sort_number_concat: 'a.period_end_date DESC, a.period_level_order DESC',
      in_sort_number_concat: "a.period_end_date ASC, a.period_level_order DESC",
    };
    let resPeriods = await GetPeriodsDataList(periodsDataReq, dispatch, history);
    if (resPeriods.length > 0) {
      let tempArray = [];
      resPeriods.map((item) => {
        let obj = {};
        obj.text = item.period_name;
        obj.id = item.period_mstr_key;
        obj.in_period_start_date = item.period_start_date;
        obj.in_period_end_date = item.period_end_date;
        obj.value = item.period_mstr_key;
        tempArray.push(obj);
        return 0;
      });

      tempArray.unshift({ text: "Select All", value: "" });
      setPeriodNameList(tempArray);
      setPeriodNameListData(tempArray);
      setPERIOD_NAME_LIST_FILTER(tempArray);
    } else {
    }
  };

  const onNoBtnClick = () => {
    setShow({
      ...isShow,
      deleteAllRows: false
    })
  }


  const onDeleteAllRowsClick = () => {
    let serverDeleteArray = data.filter((item) => item.isAdd !== true);
    setErrorObj({});
    changeCancelBtnState("disable", "grid-incell-cancel-" + versionData.custom_table_mstr_key);
    changeUpdateBtnState("disable", "grid-incell-update-" + versionData.custom_table_mstr_key);


    if (serverDeleteArray.length > 0) {
      setAPICallingState(true)
      setShow({
        ...isShow,
        deleteAllRows: false
      })
      const dataVal = {
        ...apiCallData,
        in_data_filter: searchData.in_data_filter,
        in_data_filter_count: searchData.in_data_filter_count,
        in_filter: getInFilter(),
        in_sort_number: getInSortNumber(),
        in_sort_order: getInSortOrder(),
        in_page_row_offset: 0,
        in_page_rows: defaultPageSizevs.recordTake,
        in_is_audit_log: 0,
        in_delete_flag: 1
      };
      setSelectedRowId("")
      setDeleteSelectedIds([]);
      setSelectedState({})
      getGridData(dataVal, 'delete')
    } else {
      setSelectedRowId("");
      setDeleteSelectedIds([]);
      const updatedData = data.filter((item) => item.isAdd !== true);
      setData(updatedData);
      setShow({
        ...isShow,
        deleteAllRows: false
      })
    }
  }


  const CustomComponent = () => {
    return <p dangerouslySetInnerHTML={{ __html: confirmationPopup.desc }} />;
  };

  const deleteRowCount = () => {
    const newRowsCount = gridData.filter((item) => item.isAdd).length;

    const existingGridCount = gridData.filter((item) => !item.isAdd).length;

    const baseCount =
      dataRowsCount === 0
        ? existingGridCount
        : Math.max(dataRowsCount, existingGridCount);

    return baseCount + newRowsCount;
  };

  const isFiltereApply = () => {
    return filterData.isFilter ||
      (searchData.in_data_filter_count != null &&
        searchData.in_data_filter_count !== "" &&
        searchData.in_data_filter_count !== 0)
  }


  const showDeleteAllTitle = () => {
    const isFiltered = isFiltereApply()

    if (isFiltered) {
      return `Delete Filtered Rows`
    } else {
      return `Delete All Rows`
    }
  }

  const showDeleteAllMessage = () => {
    const count = deleteRowCount()

    const isFiltered = isFiltereApply()


    if (isFiltered) {
      return (
        <>
          Are you sure you want to delete the {" "}
          <strong>{count}</strong> filtered{" "}
          {count === 1 ? "row" : "rows"}?
        </>
      )
    } else {
      return (
        <>
          Are you sure you want to delete all rows?
        </>
      )
    }
  }

  return (
    <>
      <Window
        className={"Dialog-dtulogs Dialog-lModal customtabledatacont"}
        title={<ModalTitle />}
        onClose={() => {
          onClosePopup();
        }}
        width={window.innerWidth * 0.81}
        height={window.innerHeight * 0.84}
        resizable={false}
        stage={stageChange}
        onStageChange={handleStageChange}
        modal={modal}
      >
        <EffectiveVersions
          pageProps={pageProps}
          versionData={versionData}
          effVersionState={effVersionState}
          setEffVersionState={setEffVersionState}
          effVersionLoadingState={effVersionLoadingState}
          containerRef={containerRef}
        />
        <div className="content-head customtabledatapopup">
          <HeaderPage pageProps={pageProps} headerConfig={headerConfig} versionData={versionData} />
        </div>
        <div className="content-body">
          {/* <div className="customtablemessage">columns with "*" represented with a message. message goes here</div> */}
          <div className="dtu-file-container customtablegridcont">
            {isRefreshLoading && <>{loadingPanel}</>}
            {versionData.data_filter_access === 1 ? (
              <>
                {customTableColumnsDropDown.length > 0 ? (
                  <>
                    <div className="custom-table-filter-dropdown">
                      {customTableColumnsDropDown
                        .filter((x) => x.custom_col_is_key === 1)
                        .sort((a, b) => a.custom_col_order - b.custom_col_order)
                        .map((item, i) => {
                          return (
                            <div key={i} className="nodesection">
                              <div className="k-form-field-wrap-popup valueDropdown">
                                <Label>{`${item.origin_custom_col_name}`}</Label>
                                {item.data_type_name.toLowerCase() === "boolean" ? (
                                  <DropDownList
                                    data={BOOLEAN_DRP_DATA}
                                    textField="text"
                                    dataItemKey="value"
                                    value={item.valueData}
                                    placeholder={"-- Enter Filter --"}
                                    onChange={(e) => {
                                      handleChangeDropdownValue(e, item);
                                    }}
                                  />
                                ) : item.data_type_name.toLowerCase() === "date" ? (
                                  <>
                                    <DatePicker
                                      value={item.valueData}
                                      name="date_field"
                                      format="yyyy-MM-dd"
                                      onChange={(e) => {
                                        handleDateChange(e, item);
                                      }}
                                      formatPlaceholder={{
                                        year: "yyyy",
                                        month: "mm",
                                        day: "dd",
                                      }}
                                      placeholder="yyyy-mm-dd"
                                      toggleButton={CustomToggleButton}
                                    />
                                  </>
                                ) : versionData.custom_table_type === "H" ? (
                                  <>
                                    {item.origin_custom_col_name === "Node" ? (
                                      <div className="k-form-field-wrap-popup valueDropdown">
                                        <CustomDropdown
                                          name={"nodeValue"}
                                          data={item.data}
                                          textField="text"
                                          onOpen={(dataValue) => {
                                            setNodeFields({
                                              ...nodeFields,
                                              nodeList: NODE_NAME_LIST_FILTER,
                                            });
                                            let dataIndex = customTableColumnsDropDown.findIndex(
                                              (x) => x.custom_col_mstr_key === item.custom_col_mstr_key
                                            );
                                            let customTableColData = [...customTableColumnsDropDown];
                                            customTableColData[dataIndex].data = NODE_NAME_LIST_FILTER;
                                            setCustomTableColumnsDropDown([...customTableColData]);
                                          }}
                                          // className= "k-form-field-wrap-popup valueDropdown width20em"
                                          dataItemKey="value"
                                          valueData={
                                            NODE_NAME_LIST_FILTER &&
                                            NODE_NAME_LIST_FILTER.find((c) => c.text === nodeFields.nodeValue.text)
                                          }
                                          onChange={async (e, name) => {
                                            setNodeFields({
                                              ...nodeFields,
                                              [name]: e,
                                            });
                                            setNodeNameFields({
                                              ...nodeNameFields,
                                              nodeNameValue: "",
                                              nodeNameList: [],
                                              isNodeNameLoading: true,
                                            });
                                            if (e.text !== "Select All") {
                                              await getNodeNamesForSearch(e, item);
                                              let val = [
                                                {
                                                  data_value: e.value,
                                                },
                                              ];
                                              await handleChangeDropdownValue({ value: val }, item);
                                            } else {
                                              setNodeNameFields({
                                                ...nodeNameFields,
                                                nodeNameList: [],
                                                isNodeNameLoading: false,
                                              });
                                              let val = [
                                                {
                                                  data_value: e.text,
                                                },
                                              ];
                                              handleChangeDropdownValue({ value: val }, item);
                                            }
                                          }}
                                          filterable={true}
                                          onFilterChange={(value) => handleFilterChange(value, item)}
                                          autoClose={false}
                                          autoBind={true}
                                          isSelectALl={true}
                                          dataList={NODE_NAME_LIST_FILTER}
                                          placeholder="-- Select Filter --"
                                          disabled={nodeNameFields.isNodeNameLoading}
                                        />
                                      </div>
                                    ) : item.origin_custom_col_name === "Node Name" ? (
                                      <div className="k-form-field-wrap-popup valueDropdown">
                                        <MultiSelectDropdown
                                          name={"nodeNameValue"}
                                          module="nodeNameValue"
                                          data={item.data}
                                          textField="text"
                                          dataItemKey="value"
                                          valueData={item.valueData}
                                          onOpen={(dataV) => {
                                            setNodeNameFields({
                                              ...nodeNameFields,
                                              nodeNameList: nodeNameFields.nodeNameList,
                                            });
                                            let dataIndex = customTableColumnsDropDown.findIndex(
                                              (x) => x.custom_col_mstr_key === item.custom_col_mstr_key
                                            );
                                            let customTableColData = [...customTableColumnsDropDown];
                                            customTableColData[dataIndex].data = nodeNameFields.nodeNameList;
                                            setCustomTableColumnsDropDown([...customTableColData]);
                                          }}
                                          onChange={(e, name) => {
                                            setNodeNameFields({
                                              ...nodeNameFields,
                                              [name]: e,
                                            });
                                            let val = [];
                                            e.map((item) => {
                                              let obj = {};
                                              obj.data_value = item.value;
                                              val.push(obj);
                                            });
                                            handleChangeDropdownValue(
                                              {
                                                value: val,
                                                selectedValue: e,
                                              },
                                              item
                                            );
                                          }}
                                          filterable={true}
                                          onFilterChange={(dataV) => {
                                            handleFilterChangeForNodeName(dataV, item);
                                          }}
                                          // popupSettings={{ appendTo: dropDownAppendTo }}
                                          autoClose={false}
                                          autoBind={true}
                                          dataList={nodeNameFields.nodeNameList}
                                          loading={nodeNameFields.isNodeNameLoading}
                                          placeholder={"Select Node Name"}
                                        // appendTo={assignObjRef.current}
                                        />
                                      </div>
                                    ) : item.origin_custom_col_name === "Period Name" ? (
                                      <div className="k-form-field-wrap-popup valueDropdown">
                                        <CustomDropdown
                                          name={"periodValue"}
                                          data={periodNameList}
                                          textField="text"
                                          onOpen={(dataValue) => {
                                            setPeriodFields({
                                              ...periodFields,
                                              periodList: PERIOD_NAME_LIST_FILTER,
                                            });
                                            setPeriodNameList(PERIOD_NAME_LIST_FILTER);
                                            let dataIndex = customTableColumnsDropDown.findIndex(
                                              (x) => x.custom_col_mstr_key === item.custom_col_mstr_key
                                            );
                                            let customTableColData = [...customTableColumnsDropDown];
                                            customTableColData[dataIndex].data = PERIOD_NAME_LIST_FILTER;
                                            setCustomTableColumnsDropDown([...customTableColData]);
                                          }}
                                          // className= "k-form-field-wrap-popup valueDropdown width20em"
                                          dataItemKey="value"
                                          valueData={
                                            PERIOD_NAME_LIST_FILTER &&
                                            PERIOD_NAME_LIST_FILTER.find(
                                              (c) => c.text === periodFields.periodValue.text
                                            )
                                          }
                                          onChange={async (e, name) => {
                                            setPeriodFields({
                                              ...periodFields,
                                              [name]: e,
                                            });
                                          }}
                                          filterable={true}
                                          onFilterChange={(value) => handleFilterChangePeriodName(value, item)}
                                          autoClose={false}
                                          autoBind={true}
                                          isSelectALl={true}
                                          dataList={PERIOD_NAME_LIST_FILTER}
                                          placeholder="-- Select Filter --"
                                        />
                                      </div>
                                    ) : (
                                      <MultiSelect
                                        data={item.data}
                                        filter={item.filterValue}
                                        textField="data_value"
                                        dataItemKey="custom_data_mstr_key"
                                        filterable
                                        value={item.valueData}
                                        onChange={(e) => {
                                          handleChangeDropdownValue(e, item);
                                        }}
                                        filterable={true}
                                        onFilterChange={(e) => {
                                          filterDropdownChangeValue(e, item);
                                        }}
                                        autoClose={false}
                                        autoBind={true}
                                        loading={item.loading}
                                        placeholder={"-- Enter Filter --"}
                                        disabled={false}
                                        onBlur={() => {
                                          handleBlur(item);
                                        }}
                                        listNoDataRender={
                                          item.filterValue === "" || item.filterValue === undefined
                                            ? listTextRender
                                            : item.loading === false && data && data.length === 0
                                              ? listNoDataRender
                                              : listNoDataRender
                                        }
                                      />
                                    )}
                                  </>
                                ) : (
                                  <MultiSelect
                                    data={item.data}
                                    filter={item.filterValue}
                                    textField="data_value"
                                    dataItemKey="custom_data_mstr_key"
                                    filterable
                                    value={item.valueData}
                                    onChange={(e) => {
                                      handleChangeDropdownValue(e, item);
                                    }}
                                    filterable={true}
                                    onFilterChange={(e) => {
                                      filterDropdownChangeValue(e, item);
                                    }}
                                    autoClose={false}
                                    autoBind={true}
                                    loading={item.loading}
                                    placeholder={"-- Enter Filter --"}
                                    disabled={false}
                                    onBlur={() => {
                                      handleBlur(item);
                                    }}
                                    listNoDataRender={
                                      item.filterValue === "" || item.filterValue === undefined
                                        ? listTextRender
                                        : item.loading === false && data && data.length === 0
                                          ? listNoDataRender
                                          : listNoDataRender
                                    }
                                  />
                                )}
                              </div>
                            </div>
                          );
                        })}
                      {customTableColumnsDropDown.length > 0 && (
                        <Button
                          primary={true}
                          className="searchbtn"
                          type={"submit"}
                          onClick={(e) => {
                            onSearchBtnClick();
                          }}
                          disabled={nodeNameFields.isNodeNameLoading}
                        >
                          <i className="fas fa-search"></i>
                        </Button>
                      )}
                    </div>
                    <div ref={_ref}>
                      {columns && columns.length > 0 && !effVersionLoadingState ? (
                        <DataTable
                          gridKey={gridKey}
                          resetSort={resetSort}
                          isAPICalling={isAPICalling}
                          initialLoading={initialLoading}
                          data={
                            isSearchBtnClick
                              ? gridData.map((item) => ({
                                ...item,
                                [SELECTED_FIELD]: selectedState[idGetter(item)],
                              }))
                              : []
                          }
                          errorMsg={
                            isSearchBtnClick === false ? (
                              <>
                                <i className="fas fa-question-circle">&nbsp;</i>
                                Optionally set filters and click SEARCH button to return data
                              </>
                            ) : (
                              "No Data Found"
                            )
                          }
                          id="custom-table-data-grid"
                          module={"custom-table-data-grid"}
                          editField={editFieldTier}
                          pageData={pageData}
                          dataCount={data.length}
                          customColumn={GroupColumn}
                          columns={gridColumns}
                          dataItemKey={DATA_ITEM_KEY}
                          // gridHeight={400}
                          getExportData={getExportData}
                          setExportData={setExportDataClick}
                          isExportDataClick={exportDataClick}
                          fileName={"Export_custom_table_data.xlsx"}
                          exportData={exportData}
                          rowRender={customRowRender}
                          cellRender={customCellRender}
                          itemChange={itemChange}
                          defaultPageSize={defaultPageSize}
                          pageSize={pageSize}
                          setPageSize={setPageSize}
                          handleColumnMenu={handleColumnMenu}
                          handlePageChange={handlePageChange}
                          refreshClick={onRefreshBtnClick}
                          onClearFilter={onClearFilter}
                          onSelectionChange={onSelectionChange}
                          reorderable={false}
                          originalDataCount={dataRowsCount}
                          defaultPageSizevs={defaultPageSizevs}
                          originalData={data}
                          pageDatavs={pageDatavs}
                          initialFilter={filterField}
                          initialSort={sortField}
                        />
                      ) : isAPICalling ? (
                        <LoadingPanel />
                      ) : (
                        false
                      )}
                    </div>
                  </>
                ) : (
                  <LoadingPanel />
                )}
              </>
            ) : (
              <div ref={_ref}>
                {columns && columns.length > 0 && !effVersionLoadingState ? (
                  <DataTable
                    gridKey={gridKey}
                    isAPICalling={isAPICalling}
                    initialLoading={initialLoading}
                    data={gridData.map((item) => ({
                      ...item,
                      [SELECTED_FIELD]: selectedState[idGetter(item)],
                    }))}
                    id="custom-table-data-grid"
                    module={"custom-table-data-grid"}
                    editField={editFieldTier}
                    pageData={pageData}
                    dataCount={data.length}
                    customColumn={GroupColumn}
                    columns={gridColumns}
                    dataItemKey={DATA_ITEM_KEY}
                    getExportData={getExportData}
                    setExportData={setExportDataClick}
                    isExportDataClick={exportDataClick}
                    fileName={"Export_custom_table_data.xlsx"}
                    exportData={exportData}
                    rowRender={customRowRender}
                    cellRender={customCellRender}
                    itemChange={itemChange}
                    defaultPageSize={defaultPageSize}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    handleColumnMenu={handleColumnMenu}
                    handlePageChange={handlePageChange}
                    refreshClick={onRefreshClick}
                    onClearFilter={onClearFilter}
                    onSelectionChange={onSelectionChange}
                    reorderable={false}
                    originalDataCount={dataRowsCount}
                    defaultPageSizevs={defaultPageSizevs}
                    originalData={data}
                    pageDatavs={pageDatavs}
                    initialFilter={filterField}
                    initialSort={sortField}
                  />
                ) : (
                  <LoadingPanel />
                )}
              </div>
            )}
          </div>
        </div>
      </Window>
      <DialogComponent
        title={confirmationPopup.title}
        onCancelConfirm={onCancelConfirm}
        width={"450"}
        height={"auto"}
        className={"Dialog-Delete"}
        desc={<CustomComponent />}
        visible={confirmationPopup.isVisible}
        actionBtn={confirmationPopup.actionBtn}
        titleClassName={confirmationPopup.action === "Delete" ? "delete-confirm" : "unSave-confirm"}
      />

      {isShow?.deleteAllRows &&
        <>
          <Dialog
            title={showDeleteAllTitle()}
            onClose={onNoBtnClick}
            width={"500"}
            height={"auto"}
            className={"Dialog-Delete"}
          >
            <div className="dialog-content">
              <div className="dialog-message">
                {showDeleteAllMessage()}
              </div>
            </div>

            <DialogActionsBar layout={"end"}>
              <button
                id={`dialog-btn`}
                className="k-button"
                onClick={(e) => {
                  onNoBtnClick()
                }}
                autoFocus={true}
              >
                {"Cancel"}
              </button>
              <button
                id={`dialog-btn`}
                className="k-button"
                onClick={(e) => {
                  onDeleteAllRowsClick()
                }}
                autoFocus={true}
              >
                {"Yes"}
              </button>
            </DialogActionsBar>

          </Dialog>
        </>}

      {
        isShow.dtuLogs && (
          <DtuBatchLogs visible={isShow} setShow={setShow} module={"custom_table_data"} pageProps={pageProps} />
        )
      }
      {
        isShow.dtuUpload && (
          <UploadDtu
            visible={isShow}
            setShow={setShow}
            title={"Upload Custom table Data Rows"}
            pageId={"custom_table_data"}
            versionData={versionData}
            setAPICall={onRefreshClick}
          />
        )
      }
    </>
  );
};

export const GridButton = (restProps) => {
  const args = restProps.args;

  return (
    <>
      <Button type="submit" className="cancelbtn" id={"grid-incell-cancel-" + args.custom_table_mstr_key}>
        Cancel
      </Button>
      <Button type="submit" className="primarybtn" id={"grid-incell-update-" + args.custom_table_mstr_key}>
        Save
      </Button>
    </>
  );
};
export default React.memo(CustomTablesdataPopup);
